{
  "AccountStatus": {
    "OPEN": "Open",
    "CLOSED": "Closed",
    "FROZEN": "Frozen",
    "PENDING": "Pending",
    "EDD": "EDD",
    "DORMANT": "Dormant"
  },
  "AccountProductType": {
    "CLIENT": "Client",
    "DEPOSIT": "Deposit",
    "VIRTUAL": "Virtual"
  },
  "TransactionOriginatorAccountFIATUSType": {
    "CHECKING": "Checking",
    "SAVING": "Saving"
  },
  "BridgeAccountOwnerType": {
    "individual": "Individual",
    "business": "Corporation"
  },
  "BridgeBankAccountType": {
    "us": "US",
    "iban": "IBAN"
  },
  "FeesType": {
    "domestic": "Domestic",
    "domesticIn": "Domestic In",
    "swift": "Swift",
    "swiftIn": "Swift In",
    "processingFee": "Processing Fee",
    "conversionFee": "Conversion Fee",
    "ach": "ACH"
  },
  "TransactionPaymentTransactionStatus": {
    "AUTHORIZED": "Authorized",
    "PENDING": "Pending",
    "POSTED": "Posted",
    "CANCELLED": "Cancelled"
  },
  "TransactionPaymentTransactionType": {
    "TRANSFER_IN": "Transfer In",
    "TRANSFER_OUT": "Transfer Out",
    "FEE": "Fee",
    "DEBIT_CORRECTION": "Debit Correction",
    "CREDIT_CORRECTION": "Credit Correction",
    "TRADE": "Trade",
    "INTERNAL_TRANSFER": "Internal Transfer"
  },
  "TransactionPaymentCategoryType": {
    "ADJUSTMENT": "Adjustment",
    "DEPOSIT": "Deposit",
    "EXCHANGE": "Exchange",
    "TRANSFER": "Transfer",
    "WITHDRAWAL": "Withdrawal"
  },
  "CounterPartyIntermediaryFIATPAIntermediaryType": {
    "FIAT_US": "FIAT US",
    "FIAT_CA": "FIAT CA"
  },
  "RequestAdjustmentStatus": {
    "REQUESTED": "Requested",
    "ACCEPTED": "Accepted",
    "CANCELLED": "Cancelled",
    "EXECUTED": "Executed",
    "REJECTED": "Rejected"
  },
  "RequestAdjustmentAdjustmentType": {
    "CREDIT": "Credit",
    "DEBIT": "Debit"
  },
  "WithdrawalFedwireStatus": {
    "REQUESTED": "Requested",
    "REJECTED": "Rejected",
    "EXPIRED": "Expired",
    "ACCEPTED": "Accepted",
    "EXECUTED": "Executed",
    "CANCELLED": "Cancelled"
  },
  "WithdrawalFedwireWithdrawalRail": {
    "ACH": "ACH",
    "FEDWIRE": "Fedwire",
    "SWIFT": "SWIFT",
    "CRYPTO": "Crypto",
    "EFT": "EFT"
  },
  "WithdrawalFedwirePurpose": {
    "PERSONAL_ACCOUNT": "Personal Account",
    "FAMILY": "Family",
    "INSURANCE": "Insurance",
    "INVESTMENT": "Investment",
    "REAL_ESTATE": "Real Estate",
    "TUITION": "Tuition",
    "MEDICAL": "Medical",
    "TRAVEL": "Travel",
    "TRADE_TRANSACTIONS": "Trade Transactions",
    "UTILITY": "Utility",
    "TAX": "Tax",
    "LOAN": "Loan",
    "BILLS": "Bills",
    "PAYROLL": "Payroll",
    "TELECOM": "Telecom",
    "INTELLECTUAL_PROPERTY": "Intellectual Property",
    "OTHER_BUSINESS_SERVICES": "Other Business Services",
    "CHARITABLE_DONATIONS": "Charitable Donations",
    "MORTGAGE": "Mortgage",
    "EXPENSES_REIMBURSEMENT": "Expenses Reimbursement",
    "PROFESSIONAL_SERVICES": "Professional Services",
    "MARKETING": "Marketing",
    "RENTAL_PROPERTY": "Rental Property",
    "OTHER": "Other"
  },
  "ProfileInvestingPrimarySourceOfFunds": {
    "EMPLOYMENT": "Employment",
    "SAVINGS": "Savings",
    "WINNINGS": "Winnings",
    "MARITAL": "Marital",
    "REAL_ESTATE": "Real Estate",
    "TRUST": "Trust",
    "INVESTMENT": "Investment",
    "OTHER": "Other",
    "COMPANY": "Company",
    "COMPANY_CAPITAL": "Company Capital",
    "LOAN": "Loan",
    "PRIVATE_CAPITAL": "Private Capital",
    "GRANT": "Grant"
  },
  "ProfileInvestingTotalInvestableAssets": {
    "UPTO_10M": "Up to 10M",
    "TEN_TO_50M": "10M to 50M",
    "FIFTY_TO_250M": "50M to 250M",
    "MORE_THAN_250M": "More than 250M"
  },
  "ProfileInvestingTotalAssets": {
    "UPTO_10M": "Up to 10M",
    "TEN_TO_50M": "10M to 50M",
    "FIFTY_TO_250M": "50M to 250M",
    "MORE_THAN_250M": "More than 250M"
  },
  "ProfileInvestingAssetAllocationToCrypto": {
    "UPTO_10": "Up to 10%",
    "TEN_TO_25": "10% to 25%",
    "TWENTYSIX_TO_50": "26% to 50%",
    "FIFTYONE_TO_75": "51% to 75%",
    "MORE_THAN_75": "More than 75%"
  },
  "ProfileInvestingInvestmentExperienceCrypto": {
    "LITTLE": "Little",
    "MODERATE": "Moderate",
    "SIGNIFICANT": "Significant"
  },
  "ProfileInvestingInvestmentStrategyCrypto": {
    "LOW_RISK": "Low Risk",
    "MEDIUM_RISK": "Medium Risk",
    "HIGH_RISK": "High Risk",
    "OTHER": "Other"
  },
  "ProfileInvestingInitialDepositSource": {
    "DEPOSIT": "Deposit",
    "WIRE": "Wire"
  },
  "ProfileInvestingOngoingDepositSource": {
    "DEPOSIT": "Deposit",
    "WIRE": "Wire"
  },
  "ProfileInvestingFrequencyOfCryptoTransactions": {
    "DAILY": "Daily",
    "WEEKLY": "Weekly",
    "BIWEEKLY": "Biweekly",
    "MONTHLY": "Monthly",
    "QUARTERLY": "Quarterly",
    "SEMI_ANNUALLY": "Semi-Annually"
  },
  "ProfileInvestingCryptoInvestmentPlans": {
    "CUSTODY": "Custody",
    "STAKING": "Staking",
    "TRADING": "Trading",
    "LENDING": "Lending",
    "BORROWING": "Borrowing"
  },
  "ProfileInvestingTradesPerMonth": {
    "UPTO_20": "Up to 20",
    "TWENTYONE_TO_30": "21 to 30",
    "THIRTYONE_TO_100": "31 to 100",
    "ONEHUNDREDANDONE_TO_200": "101 to 200",
    "TWOHUNDREDANDONE_TO_400": "201 to 400",
    "MORE_THAN_400": "More than 400"
  },
  "ProfileInvestingUsdValueOfCrypto": {
    "UPTO_10K": "Up to 10K",
    "TEN_TO_100K": "10K to 100K",
    "ONEHUNDREDK_TO_1M": "100K to 1M",
    "ONE_TO_10M": "1M to 10M",
    "TEN_TO_50M": "10M to 50M",
    "FIFTY_TO_250M": "50M to 250M",
    "MORE_THAN_250M": "More than 250M"
  },
  "InvestmentProfile": {
    "UPTO_10K": "Up to 10K",
    "TEN_TO_100K": "10K to 100K",
    "ONEHUNDREDK_TO_1M": "100K to 1M",
    "ONE_TO_10M": "1M to 10M",
    "TEN_TO_50M": "10M to 50M",
    "FIFTY_TO_250M": "50M to 250M",
    "MORE_THAN_250M": "More than 250M",
    "UPTO_5": "Up to 5",
    "FIVE_TO_10": "5 to 10",
    "TEN_TO_25": "10 to 25",
    "MORE_THAN_25": "More than 25",
    "UPTO_1K": "Up to 1K",
    "ONE_TO_100K": "1K to 100K",
    "MILLION_TO_5M": "1M to 5M",
    "MORE_THAN_5M": "More than 5M",
    "EMPLOYMENT": "Employment",
    "SAVINGS": "Savings",
    "WINNINGS": "Winnings",
    "MARITAL": "Marital",
    "REAL_ESTATE": "Real Estate",
    "TRUST": "Trust",
    "INVESTMENT": "Investment",
    "OTHER": "Other",
    "COMPANY": "Company",
    "COMPANY_CAPITAL": "Company Capital",
    "LOAN": "Loan",
    "PRIVATE_CAPITAL": "Private Capital",
    "GRANT": "Grant"
  },
  "ProfileInvestingFrequencyOfTransactions": {
    "DAILY": "Daily",
    "WEEKLY": "Weekly",
    "BIWEEKLY": "Biweekly",
    "MONTHLY": "Monthly",
    "QUARTERLY": "Quarterly",
    "SEMI_ANNUALLY": "Semi-Annually"
  },
  "ProfileInvestingMonthlyCryptoInvestmentDeposit": {
    "UPTO_1K": "Up to 1K",
    "ONE_TO_100K": "1K to 100K",
    "ONEHUNDREDK_TO_1M": "100K to 1M",
    "MILLION_TO_5M": "1M to 5M",
    "MORE_THAN_5M": "More than 5M"
  },
  "ProfileInvestingMonthlyInvestmentDeposit": {
    "UPTO_1K": "Up to 1K",
    "ONE_TO_100K": "1K to 100K",
    "ONEHUNDREDK_TO_1M": "100K to 1M",
    "MILLION_TO_5M": "1M to 5M",
    "MORE_THAN_5M": "More than 5M"
  },
  "ProfileInvestingMonthlyCryptoDeposits": {
    "UPTO_5": "Up to 5",
    "FIVE_TO_10": "5 to 10",
    "TEN_TO_25": "10 to 25",
    "MORE_THAN_25": "More than 25"
  },
  "ProfileInvestingMonthlyDeposits": {
    "UPTO_5": "Up to 5",
    "FIVE_TO_10": "5 to 10",
    "TEN_TO_25": "10 to 25",
    "MORE_THAN_25": "More than 25"
  },
  "ProfileInvestingMonthlyCryptoInvestmentWithdrawal": {
    "UPTO_1K": "Up to 1K",
    "ONE_TO_100K": "1K to 100K",
    "ONEHUNDREDK_TO_1M": "100K to 1M",
    "MILLION_TO_5M": "1M to 5M",
    "MORE_THAN_5M": "More than 5M"
  },
  "ProfileInvestingMonthlyInvestmentWithdrawal": {
    "UPTO_1K": "Up to 1K",
    "ONE_TO_100K": "1K to 100K",
    "ONEHUNDREDK_TO_1M": "100K to 1M",
    "MILLION_TO_5M": "1M to 5M",
    "MORE_THAN_5M": "More than 5M"
  },
  "ProfileInvestingMonthlyCryptoWithdrawals": {
    "UPTO_5": "Up to 5",
    "FIVE_TO_10": "5 to 10",
    "TEN_TO_25": "10 to 25",
    "MORE_THAN_25": "More than 25"
  },
  "ProfileInvestingMonthlyWithdrawals": {
    "UPTO_5": "Up to 5",
    "FIVE_TO_10": "5 to 10",
    "TEN_TO_25": "10 to 25",
    "MORE_THAN_25": "More than 25"
  },
  "CounterPartyFIATPACounterpartyType": {
    "FIAT_US": "FIAT US",
    "FIAT_US_LINKED": "FIAT US Linked",
    "FIAT_CA": "FIAT CA",
    "FIAT_CA_LINKED": "FIAT CA Linked",
    "CRYPTO": "Crypto"
  },
  "CounterPartyFIATPASupportedRails": {
    "SWIFT": "SWIFT"
  },
  "ApplicationFieldErrorFieldName": {
    "customer_id": "Customer ID",
    "account_to_open": "Account to Open",
    "product_type": "Product Type",
    "asset_type": "Asset Type",
    "id": "ID",
    "registered_name": "Registered Name",
    "trading_name": "Trading Name",
    "registered_number": "Registered Number",
    "registered_address.unit_number": "Registered Address Unit Number",
    "registered_address.address_line1": "Registered Address Line 1",
    "registered_address.address_line2": "Registered Address Line 2",
    "registered_address.address_line3": "Registered Address Line 3",
    "registered_address.city": "Registered Address City",
    "registered_address.state": "Registered Address State",
    "registered_address.postal_code": "Registered Address Postal Code",
    "registered_address.country_code": "Registered Address Country Code",
    "telephone_number": "Telephone Number",
    "website_address": "Website Address",
    "state_of_incorporation": "State of Incorporation",
    "country_of_incorporation": "Country of Incorporation",
    "corporate_entity_type": "Corporate Entity Type",
    "contact_title": "Contact Title",
    "contact_first_name": "Contact First Name",
    "contact_last_name": "Contact Last Name",
    "contact_telephone_number": "Contact Telephone Number",
    "contact_email_address": "Contact Email Address",
    "physical_address.unit_number": "Physical Address Unit Number",
    "physical_address.address_line1": "Physical Address Line 1",
    "physical_address.address_line2": "Physical Address Line 2",
    "physical_address.address_line3": "Physical Address Line 3",
    "physical_address.city": "Physical Address City",
    "physical_address.state": "Physical Address State",
    "physical_address.postal_code": "Physical Address Postal Code",
    "physical_address.country_code": "Physical Address Country Code",
    "primary_business": "Primary Business",
    "description_of_business_nature": "Description of Business Nature",
    "is_charitable": "Is Charitable",
    "business_jurisdictions": "Business Jurisdictions",
    "funds_send_receive_jurisdictions": "Funds Send/Receive Jurisdictions",
    "new_york_office": "New York Office",
    "engage_in_activities": "Engage in Activities",
    "regulated_status": "Regulated Status",
    "regulation_agency_regulation_number": "Regulation Agency Regulation Number",
    "control_exemption_reason": "Control Exemption Reason",
    "vendors_and_counterparties": "Vendors and Counterparties",
    "primary_source_of_funds": "Primary Source of Funds",
    "total_investable_assets": "Total Investable Assets",
    "total_assets": "Total Assets",
    "asset_allocation_to_crypto": "Asset Allocation to Crypto",
    "investment_experience_crypto": "Investment Experience in Crypto",
    "investment_strategy_crypto": "Investment Strategy in Crypto",
    "initial_deposit_source": "Initial Deposit Source",
    "ongoing_deposit_source": "Ongoing Deposit Source",
    "frequency_of_crypto_transactions": "Frequency of Crypto Transactions",
    "crypto_investment_plans": "Crypto Investment Plans",
    "investment_proceeds_use": "Investment Proceeds Use",
    "expected_crypto_assets": "Expected Crypto Assets",
    "perform_transfers_with_unhosted_wallets": "Perform Transfers with Unhosted Wallets",
    "known_unhosted_wallet_addresses": "Known Unhosted Wallet Addresses",
    "trades_per_month": "Trades per Month",
    "usd_value_of_crypto": "USD Value of Crypto",
    "frequency_of_transactions": "Frequency of Transactions",
    "monthly_crypto_investment_deposit": "Monthly Crypto Investment Deposit",
    "monthly_investment_deposit": "Monthly Investment Deposit",
    "monthly_crypto_deposits": "Monthly Crypto Deposits",
    "monthly_deposits": "Monthly Deposits",
    "monthly_crypto_investment_withdrawal": "Monthly Crypto Investment Withdrawal",
    "monthly_investment_withdrawal": "Monthly Investment Withdrawal",
    "monthly_crypto_withdrawals": "Monthly Crypto Withdrawals",
    "monthly_withdrawals": "Monthly Withdrawals",
    "trade_internationally": "Trade Internationally",
    "trade_jurisdictions": "Trade Jurisdictions"
  },
  "ApplicationFieldErrorFieldStatus": {
    "INCOMPLETE": "Incomplete",
    "READY_FOR_SUBMISSION": "Ready for Submission",
    "CHANGES_REQUESTED": "Changes Requested",
    "APPROVED": "Approved"
  },
  "CounterPartyProfileFIATCALineOfBusiness": {
    "ARTS_AND_ANTIQUES": "Arts and Antiques",
    "AGRICULTURE": "Agriculture",
    "AUDIT_VIDEO": "Audit Video",
    "AUTOMOTIVE": "Automotive",
    "BANK_CREDIT_UNION": "Bank/Credit Union",
    "BIOTECH_PHARMACEUTICAL": "Biotech/Pharmaceutical",
    "BOOKSELLER": "Bookseller",
    "CONSTRUCTION": "Construction",
    "CASINOS_GAMBLING": "Casinos/Gambling",
    "CLOTHING": "Clothing",
    "CONSULTING_PROFESSIONAL_SERVICES": "Consulting/Professional Services",
    "CRYPTOCURRENCY": "Cryptocurrency",
    "ECIGARETTES_TOBACCO": "E-cigarettes/Tobacco",
    "ENERGY_CHEMICAL_FUEL": "Energy/Chemical/Fuel",
    "ENGINEERING": "Engineering",
    "ADULT_ENTERTAINMENT": "Adult Entertainment",
    "FINANCIAL_AND_CORPORATE_SERVICES": "Financial and Corporate Services",
    "FOOD_AND_BEVERAGE": "Food and Beverage",
    "FREIGHT_MARINE_SHIPPING_SERVICES": "Freight/Marine/Shipping Services",
    "GIFTWARE_SEASONAL": "Giftware/Seasonal",
    "GOVERNMENT_PUBLIC_SERVICES": "Government/Public Services",
    "HIGH_TECH_SOFTWARE_TELECOMS": "High Tech/Software/Telecoms",
    "HOSPITALITY": "Hospitality",
    "HOUSEHOLD_GOOD_FURNITURE": "Household Goods/Furniture",
    "HUMAN_RESOURCE_SERVICES": "Human Resource Services",
    "INDUSTRIAL_EQUIPMENT": "Industrial Equipment",
    "INFORMATION_TECHNOLOGY": "Information Technology",
    "INSURANCE": "Insurance",
    "JEWELLERY_OPTICAL": "Jewellery/Optical",
    "LAW": "Law",
    "MANUFACTURING": "Manufacturing",
    "MARKETING": "Marketing",
    "MEDIA_PUBLISHING": "Media/Publishing",
    "MEDICAL_HEALTHCARE": "Medical/Healthcare",
    "MEDICAL_TOURISM": "Medical Tourism",
    "MINING": "Mining",
    "MONEY_SERVICE_BUSINESS": "Money Service Business",
    "NON_PROFIT_CHARITY": "Non-Profit/Charity",
    "ONLINE_RETAIL": "Online Retail",
    "PAYROLL": "Payroll",
    "PENSION": "Pension",
    "PERSONAL_CARE_PRODUCTS": "Personal Care Products",
    "PHOTOGRAPHY": "Photography",
    "REAL_ESTATE": "Real Estate",
    "RECREATIONAL_ACTIVITIES": "Recreational Activities",
    "RELIGIOUS_ORGANISATION": "Religious Organisation",
    "RETAIL": "Retail",
    "SECURITY": "Security",
    "SPORTING_RECREATIONAL_PRODUCTS": "Sporting/Recreational Products",
    "TRANSPORT": "Transport",
    "UNIVERSITY_EDUCATION": "University/Education",
    "UTILITIES": "Utilities",
    "WASTE_MANAGEMENT": "Waste Management",
    "WINE_LIQUOR": "Wine/Liquor",
    "TECHNICAL_SUPPORT": "Technical Support",
    "OTHER": "Other"
  },
  "CounterPartyProfileFIATCARelationshipToCustomer": {
    "SPOUSE": "Spouse",
    "EX_SPOUSE": "Ex-Spouse",
    "CHILDREN": "Children",
    "PARENT": "Parent",
    "SIBLING": "Sibling",
    "RELATIVE": "Relative",
    "SELF": "Self",
    "FRIEND": "Friend",
    "BUSINESS_PARTNER": "Business Partner",
    "CUSTOMER": "Customer",
    "EMPLOYEE": "Employee",
    "BRANCH_OFFICE": "Branch Office",
    "SUBSIDIARY_COMPANY": "Subsidiary Company",
    "HOLDING_COMPANY": "Holding Company",
    "SUPPLIER": "Supplier",
    "CREDITOR": "Creditor",
    "DEBTOR": "Debtor",
    "FRANCHISEE": "Franchisee",
    "NOT_RELATED": "Not Related"
  },
  "CounterPartyLinkingDetailsMXLinkingProvider": {
    "MX": "MX"
  },
  "IndividualCustomerUsResidencyStatus": {
    "US_CITIZEN": "US Citizen",
    "RESIDENT_ALIEN": "Resident Alien",
    "NON_RESIDENT_ALIEN": "Non-Resident Alien"
  },
  "CorporationApplicationCorporateEntityType": {
    "C_CORP_PRIVATE": "C Corp (Private)",
    "C_CORP_PUBLIC": "C Corp (Public)",
    "HNWI": "HNWI",
    "LLC": "LLC",
    "LLP": "LLP",
    "LP": "LP",
    "S_CORP": "S Corp",
    "SOLE_PROP": "Sole Prop",
    "TRUST": "Trust",
    "NON_PROFIT": "Non-Profit",
    "OTHER": "Other"
  },
  "InstructionCryptoInstructionType": {
    "CRYPTO": "Crypto",
    "ACH": "ACH",
    "FEDWIRE": "Fedwire"
  },
  "CounterPartyProfileFIATPALineOfBusiness": {
    "ARTS_AND_ANTIQUES": "Arts and Antiques",
    "AGRICULTURE": "Agriculture",
    "AUDIT_VIDEO": "Audit Video",
    "AUTOMOTIVE": "Automotive",
    "BANK_CREDIT_UNION": "Bank/Credit Union",
    "BIOTECH_PHARMACEUTICAL": "Biotech/Pharmaceutical",
    "BOOKSELLER": "Bookseller",
    "CONSTRUCTION": "Construction",
    "CASINOS_GAMBLING": "Casinos/Gambling",
    "CLOTHING": "Clothing",
    "CONSULTING_PROFESSIONAL_SERVICES": "Consulting/Professional Services",
    "CRYPTOCURRENCY": "Cryptocurrency",
    "ECIGARETTES_TOBACCO": "E-cigarettes/Tobacco",
    "ENERGY_CHEMICAL_FUEL": "Energy/Chemical/Fuel",
    "ENGINEERING": "Engineering",
    "ADULT_ENTERTAINMENT": "Adult Entertainment",
    "FINANCIAL_AND_CORPORATE_SERVICES": "Financial and Corporate Services",
    "FOOD_AND_BEVERAGE": "Food and Beverage",
    "FREIGHT_MARINE_SHIPPING_SERVICES": "Freight/Marine/Shipping Services",
    "GIFTWARE_SEASONAL": "Giftware/Seasonal",
    "GOVERNMENT_PUBLIC_SERVICES": "Government/Public Services",
    "HIGH_TECH_SOFTWARE_TELECOMS": "High Tech/Software/Telecoms",
    "HOSPITALITY": "Hospitality",
    "HOUSEHOLD_GOOD_FURNITURE": "Household Goods/Furniture",
    "HUMAN_RESOURCE_SERVICES": "Human Resource Services",
    "INDUSTRIAL_EQUIPMENT": "Industrial Equipment",
    "INFORMATION_TECHNOLOGY": "Information Technology",
    "INSURANCE": "Insurance",
    "JEWELLERY_OPTICAL": "Jewellery/Optical",
    "LAW": "Law",
    "MANUFACTURING": "Manufacturing",
    "MARKETING": "Marketing",
    "MEDIA_PUBLISHING": "Media/Publishing",
    "MEDICAL_HEALTHCARE": "Medical/Healthcare",
    "MEDICAL_TOURISM": "Medical Tourism",
    "MINING": "Mining",
    "MONEY_SERVICE_BUSINESS": "Money Service Business",
    "NON_PROFIT_CHARITY": "Non-Profit/Charity",
    "ONLINE_RETAIL": "Online Retail",
    "PAYROLL": "Payroll",
    "PENSION": "Pension",
    "PERSONAL_CARE_PRODUCTS": "Personal Care Products",
    "PHOTOGRAPHY": "Photography",
    "REAL_ESTATE": "Real Estate",
    "RECREATIONAL_ACTIVITIES": "Recreational Activities",
    "RELIGIOUS_ORGANISATION": "Religious Organisation",
    "RETAIL": "Retail",
    "SECURITY": "Security",
    "SPORTING_RECREATIONAL_PRODUCTS": "Sporting/Recreational Products",
    "TRANSPORT": "Transport",
    "UNIVERSITY_EDUCATION": "University/Education",
    "UTILITIES": "Utilities",
    "WASTE_MANAGEMENT": "Waste Management",
    "WINE_LIQUOR": "Wine/Liquor",
    "TECHNICAL_SUPPORT": "Technical Support",
    "OTHER": "Other"
  },
  "CounterPartyProfileFIATPARelationshipToCustomer": {
    "SPOUSE": "Spouse",
    "EX_SPOUSE": "Ex-Spouse",
    "CHILDREN": "Children",
    "PARENT": "Parent",
    "SIBLING": "Sibling",
    "RELATIVE": "Relative",
    "SELF": "Self",
    "FRIEND": "Friend",
    "BUSINESS_PARTNER": "Business Partner",
    "CUSTOMER": "Customer",
    "EMPLOYEE": "Employee",
    "BRANCH_OFFICE": "Branch Office",
    "SUBSIDIARY_COMPANY": "Subsidiary Company",
    "HOLDING_COMPANY": "Holding Company",
    "SUPPLIER": "Supplier",
    "CREDITOR": "Creditor",
    "DEBTOR": "Debtor",
    "FRANCHISEE": "Franchisee",
    "NOT_RELATED": "Not Related"
  },
  "CounterPartyFIATCACounterpartyType": {
    "FIAT_US": "FIAT US",
    "FIAT_US_LINKED": "FIAT US Linked",
    "FIAT_CA": "FIAT CA",
    "FIAT_CA_LINKED": "FIAT CA Linked",
    "CRYPTO": "Crypto"
  },
  "CounterPartyFIATCASupportedRails": {
    "EFT": "EFT",
    "SWIFT": "SWIFT"
  },
  "CounterPartyIntermediaryFIATCAIntermediaryType": {
    "FIAT_US": "FIAT US",
    "FIAT_CA": "FIAT CA"
  },
  "TransactionOriginatorFIATUSOriginatorType": {
    "FIAT_US": "FIAT US",
    "FIAT_US_LINKED": "FIAT US Linked",
    "FIAT_CA": "FIAT CA",
    "FIAT_CA_LINKED": "FIAT CA Linked",
    "CRYPTO": "Crypto"
  },
  "TransactionOriginatorFIATUSRail": {
    "ACH": "ACH",
    "FEDWIRE": "Fedwire",
    "SWIFT": "SWIFT"
  },
  "CounterPartyAccountCRYPTOWalletType": {
    "INSTITUTION": "Institution",
    "OTHER": "Other",
    "UNKNOWN": "Unknown"
  },
  "CustomerCustomerType": {
    "INDIVIDUAL": "Individual",
    "CORPORATION": "Corporation"
  },
  "RequestIndividualType": {
    "OFFICER": "Officer",
    "BENEFICIAL_OWNER": "Beneficial Owner",
    "CONTROL_PERSON": "Control Person",
    "AUTHORIZED_PERSON": "Authorized Person"
  },
  "CustomerStatus": {
    "ACTIVE": "Active",
    "CLOSED": "Closed",
    "FROZEN": "Frozen",
    "PENDING": "Pending",
    "EDD": "EDD",
    "DORMANT": "Dormant"
  },
  "CounterPartyFIATJPCounterpartyType": {
    "FIAT_US": "FIAT US",
    "FIAT_US_LINKED": "FIAT US Linked",
    "FIAT_CA": "FIAT CA",
    "FIAT_CA_LINKED": "FIAT CA Linked",
    "CRYPTO": "Crypto"
  },
  "CounterPartyFIATJPSupportedRails": {
    "SWIFT": "SWIFT"
  },
  "CounterPartyFIATCNCounterpartyType": {
    "FIAT_US": "FIAT US",
    "FIAT_US_LINKED": "FIAT US Linked",
    "FIAT_CA": "FIAT CA",
    "FIAT_CA_LINKED": "FIAT CA Linked",
    "CRYPTO": "Crypto"
  },
  "CounterPartyFIATCNSupportedRails": {
    "SWIFT": "SWIFT"
  },
  "DepositPullStatus": {
    "REQUESTED": "Requested",
    "EXECUTED": "Executed",
    "FAILURE": "Failure"
  },
  "DepositPullDepositType": {
    "PUSH": "Push",
    "PULL": "Pull"
  },
  "BridgeLiquidationAddressChain": {
    "arbitrum": "Arbitrum",
    "avalanche_c_chain": "Avalanche C-Chain",
    "base": "Base",
    "ethereum": "Ethereum",
    "optimism": "Optimism",
    "polygon": "Polygon",
    "solana": "Solana",
    "stellar": "Stellar",
    "tron": "Tron"
  },
  "BridgeVirtualAccountChain": {
    "arbitrum": "Arbitrum",
    "avalanche_c_chain": "Avalanche C-Chain",
    "base": "Base",
    "ethereum": "Ethereum",
    "optimism": "Optimism",
    "polygon": "Polygon",
    "solana": "Solana",
    "stellar": "Stellar"
  },
  "BridgeVirtualAccountPaymentCurrency": {
    "usdb": "USDB",
    "usdc": "USDC",
    "usdt": "USDT",
    "dai": "DAI",
    "pyusd": "PYUSD"
  },
  "PrimaryPurposeEnum": {
    "business_transactions": "Business Transactions",
    "charitable_donations": "Charitable Donations",
    "investment_purposes": "Investment Purposes",
    "other": "Other",
    "payments_to_friends_or_family_abroad": "Payments to Friends or Family Abroad",
    "personal_or_living_expenses": "Personal or Living Expenses",
    "protect_wealth": "Protect Wealth",
    "purchase_goods_and_services": "Purchase Goods and Services",
    "receive_payments_for_goods_and_services": "Receive Payments for Goods and Services",
    "tax_optimization": "Tax Optimization",
    "payroll": "Payroll"
  },
  "BridgeMostRecentOccupation": {
    "132011": "132011 - Accountant And Auditor",
    "272011": "272011 - Actor",
    "152011": "152011 - Actuary",
    "291291": "291291 - Acupuncturist",
    "519191": "519191 - Adhesive Bonding Machine Operator And Tender",
    "113012": "113012 - Administrative Services Manager",
    "112011": "112011 - Advertising And Promotions Manager",
    "413011": "413011 - Advertising Sales Agent",
    "172011": "172011 - Aerospace Engineer",
    "131011": "131011 - Agent And Business Manager Of Artists",
    "194010": "194010 - Agricultural And Food Science Technician",
    "191010": "191010 - Agricultural And Food Scientist",
    "172021": "172021 - Agricultural Engineer",
    "452011": "452011 - Agricultural Inspector",
    "532020": "532020 - Air Traffic Controller And Airfield Operations Specialist",
    "493011": "493011 - Aircraft Mechanic And Service Technician",
    "532010": "532010 - Aircraft Pilots And Flight Engineer",
    "512011": "512011 - Aircraft Structure Assembler",
    "533011": "533011 - Ambulance Driver And Attendant",
    "452021": "452021 - Animal Breeder",
    "392021": "392021 - Animal Caretaker",
    "339011": "339011 - Animal Control Worker",
    "392011": "392011 - Animal Trainer",
    "171011": "171011 - Architect",
    "173011": "173011 - Architectural And Civil Drafter",
    "119041": "119041 - Architectural And Engineering Manager",
    "254010": "254010 - Archivist Curator And Museum Technician",
    "271010": "271010 - Artist And Related Worker",
    "192010": "192010 - Astronomer And Physicist",
    "272021": "272021 - Athletes And Sports Competitor",
    "192021": "192021 - Atmospheric And Space Scientist",
    "291181": "291181 - Audiologist",
    "492097": "492097 - Audiovisual Equipment Installer And Repairer",
    "493021": "493021 - Automotive Body And Related Repairer",
    "493022": "493022 - Automotive Glass Installer And Repairer",
    "493023": "493023 - Automotive Service Technician And Mechanic",
    "492091": "492091 - Avionics Technician",
    "396010": "396010 - Baggage Porter Bellhop And Concierge",
    "333011": "333011 - Bailiff",
    "513011": "513011 - Baker",
    "395011": "395011 - Barber",
    "353011": "353011 - Bartender",
    "433011": "433011 - Bill And Account Collector",
    "433021": "433021 - Billing And Posting Clerk",
    "172031": "172031 - Bioengineer And Biomedical Engineer",
    "191020": "191020 - Biological Scientist",
    "194021": "194021 - Biological Technician",
    "472011": "472011 - Boilermaker",
    "433031": "433031 - Bookkeeping Accounting And Auditing Clerk",
    "472020": "472020 - Brickmason Blockmason And Stonemason",
    "273011": "273011 - Broadcast Announcer And Radio Disc Jockey",
    "274010": "274010 - Broadcast Sound And Lighting Technician",
    "434011": "434011 - Brokerage Clerk",
    "132031": "132031 - Budget Analyst",
    "493031": "493031 - Bus And Truck Mechanic And Diesel Engine Specialist",
    "131199": "131199 - Business Operations Specialist Other",
    "513020": "513020 - Butcher And Other Meat Processing Worker",
    "131021": "131021 - Buyer And Purchasing Agent Farm Products",
    "517011": "517011 - Cabinetmaker And Bench Carpenter",
    "292031": "292031 - Cardiovascular Technologist And Technician",
    "435011": "435011 - Cargo And Freight Agent",
    "472031": "472031 - Carpenter",
    "472040": "472040 - Carpet Floor And Tile Installer And Finisher",
    "412010": "412010 - Cashier",
    "472050": "472050 - Cement Mason Concrete Finisher And Terrazzo Worker",
    "351011": "351011 - Chef And Head Cook",
    "172041": "172041 - Chemical Engineer",
    "519010": "519010 - Chemical Processing Machine Operator And Tender",
    "194031": "194031 - Chemical Technician",
    "192030": "192030 - Chemist And Materials Scientist",
    "111011": "111011 - Chief Executive",
    "211021": "211021 - Child Family And School Social Worker",
    "399011": "399011 - Childcare Worker",
    "291011": "291011 - Chiropractor",
    "172051": "172051 - Civil Engineer",
    "131030": "131030 - Claims Adjuster Appraiser Examiner And Investigator",
    "537061": "537061 - Cleaner Of Vehicles And Equipment",
    "212011": "212011 - Clergy",
    "193033": "193033 - Clinical And Counseling Psychologist",
    "292010": "292010 - Clinical Laboratory Technologist And Technician",
    "272022": "272022 - Coaches And Scout",
    "499091": "499091 - Coin Vending And Amusement Machine Servicer And Repairer",
    "271021": "271021 - Commercial And Industrial Designer",
    "499092": "499092 - Commercial Diver",
    "432099": "432099 - Communications Equipment Operator Other",
    "113111": "113111 - Compensation And Benefits Manager",
    "131141": "131141 - Compensation Benefits And Job Analysis Specialist",
    "131041": "131041 - Compliance Officer",
    "151221": "151221 - Computer And Information Research Scientist",
    "113021": "113021 - Computer And Information Systems Manager",
    "172061": "172061 - Computer Hardware Engineer",
    "151241": "151241 - Computer Network Architect",
    "519160": "519160 - Computer Numerically Controlled Tool Operator And Programmer",
    "151299": "151299 - Computer Occupation Other",
    "151251": "151251 - Computer Programmer",
    "151230": "151230 - Computer Support Specialist",
    "151211": "151211 - Computer Systems Analyst",
    "492011": "492011 - Computer Automated Teller And Office Machine Repairer",
    "191030": "191030 - Conservation Scientist And Forester",
    "474011": "474011 - Construction And Building Inspector",
    "472070": "472070 - Construction Equipment Operator",
    "472061": "472061 - Construction Laborer",
    "119021": "119021 - Construction Manager",
    "499010": "499010 - Control And Valve Installer And Repairer",
    "5370XX": "5370XX - Conveyor Dredge And Hoist And Winch Operator",
    "352010": "352010 - Cook",
    "333012": "333012 - Correctional Officer And Jailer",
    "434021": "434021 - Correspondence Clerk",
    "131051": "131051 - Cost Estimator",
    "211019": "211019 - Counselor Other",
    "412021": "412021 - Counter And Rental Clerk",
    "435021": "435021 - Courier And Messenger",
    "273092": "273092 - Court Reporter And Simultaneous Captioner",
    "434031": "434031 - Court Municipal And License Clerk",
    "537021": "537021 - Crane And Tower Operator",
    "132041": "132041 - Credit Analyst",
    "434041": "434041 - Credit Authorizer Checker And Clerk",
    "132070": "132070 - Credit Counselor And Loan Officer",
    "339091": "339091 - Crossing Guard And Flagger",
    "519020": "519020 - Crushing Grinding Polishing Mixing And Blending Worker",
    "434051": "434051 - Customer Service Representative",
    "519030": "519030 - Cutting Worker",
    "514031": "514031 - Cutting Punching And Press Machine Operator",
    "272030": "272030 - Dancer And Choreographer",
    "439021": "439021 - Data Labeler And Data Entry Keyer",
    "15124X": "15124X - Database Administrator And Architect",
    "519080": "519080 - Dental And Ophthalmic Laboratory Technician",
    "319091": "319091 - Dental Assistant",
    "291292": "291292 - Dental Hygienist",
    "291020": "291020 - Dentist",
    "475010": "475010 - Derrick Rotary Drill And Service Unit Operator",
    "439031": "439031 - Desktop Publisher",
    "333021": "333021 - Detective And Criminal Investigator",
    "292032": "292032 - Diagnostic Medical Sonographer",
    "29205X": "29205X - Dietetic Technician And Ophthalmic Medical Technician",
    "291031": "291031 - Dietitian And Nutritionist",
    "359011": "359011 - Dining Room And Cafeteria Attendant",
    "212021": "212021 - Director Religious Activities And Education",
    "272091": "272091 - Disc Jockey Except Radio",
    "359021": "359021 - Dishwasher",
    "435032": "435032 - Dispatcher Except Police Fire And Ambulance",
    "419091": "419091 - Door To Door Sales Worker News And Street Vendor",
    "533030": "533030 - Driver Sales Worker And Truck Driver",
    "472080": "472080 - Drywall Installer Ceiling Tile Installer And Taper",
    "475023": "475023 - Earth Driller Except Oil And Gas",
    "193011": "193011 - Economist",
    "273041": "273041 - Editor",
    "119030": "119030 - Education And Childcare Administrator",
    "211012": "211012 - Educational Guidance And Career Counselor And Advisor",
    "492092": "492092 - Electric Motor Power Tool And Related Repairer",
    "173023": "173023 - Electrical And Electronic Engineering Technician",
    "172070": "172070 - Electrical And Electronics Engineer",
    "492093": "492093 - Electrical And Electronics Installer And Repairer",
    "49209X": "49209X - Electrical And Electronics Repairer Industrial And Utility",
    "499051": "499051 - Electrical Power Line Installer And Repairer",
    "512020": "512020 - Electrical Electronics And Electromechanical Assembler",
    "472111": "472111 - Electrician",
    "252020": "252020 - Elementary And Middle School Teacher",
    "474021": "474021 - Elevator And Escalator Installer And Repairer",
    "434061": "434061 - Eligibility Interviewer Government Programs",
    "3940XX": "3940XX - Embalmer Crematory Operator And Funeral Attendant",
    "119161": "119161 - Emergency Management Director",
    "292042": "292042 - Emergency Medical Technician",
    "291214": "291214 - Emergency Medicine Physician",
    "512031": "512031 - Engine And Other Machine Assembler",
    "172199": "172199 - Engineer Other",
    "272099": "272099 - Entertainer And Performer Other",
    "119070": "119070 - Entertainment And Recreation Manager",
    "172081": "172081 - Environmental Engineer",
    "194040": "194040 - Environmental Science And Geoscience Technician",
    "192041": "192041 - Environmental Scientist And Specialist",
    "519194": "519194 - Etcher And Engraver",
    "475022": "475022 - Excavating And Loading Machine And Dragline Operator",
    "436011": "436011 - Executive Secretary And Administrative Assistant",
    "291128": "291128 - Exercise Physiologist",
    "399031": "399031 - Exercise Trainer And Group Fitness Instructor",
    "475032": "475032 - Explosives Worker Ordnance Handling Expert And Blaster",
    "519041": "519041 - Extruding Forming Pressing And Compacting Machine Setter",
    "113013": "113013 - Facilities Manager",
    "119013": "119013 - Farmer Rancher And Other Agricultural Manager",
    "271022": "271022 - Fashion Designer",
    "353023": "353023 - Fast Food And Counter Worker",
    "474031": "474031 - Fence Erector",
    "434071": "434071 - File Clerk",
    "132051": "132051 - Financial And Investment Analyst",
    "433099": "433099 - Financial Clerk Other",
    "132061": "132061 - Financial Examiner",
    "113031": "113031 - Financial Manager",
    "332020": "332020 - Fire Inspector",
    "332011": "332011 - Firefighter",
    "552010": "552010 - First Line Enlisted Military Supervisor",
    "471011": "471011 - First Line Supervisor Of Construction Trades And Extraction Worker",
    "331011": "331011 - First Line Supervisor Of Correctional Officer",
    "451011": "451011 - First Line Supervisor Of Farming Fishing And Forestry Worker",
    "331021": "331021 - First Line Supervisor Of Firefighting And Prevention Worker",
    "351012": "351012 - First Line Supervisor Of Food Preparation And Serving Workers",
    "371011": "371011 - First Line Supervisor Of Housekeeping And Janitorial Workers",
    "371012": "371012 - First Line Supervisor Of Landscaping Lawn Service And Groundskeeping Workers",
    "491011": "491011 - First Line Supervisor Of Mechanics Installers And Repairers",
    "411012": "411012 - First Line Supervisor Of Non Retail Sales Workers",
    "431011": "431011 - First Line Supervisor Of Office And Administrative Support Workers",
    "331012": "331012 - First Line Supervisor Of Police And Detective",
    "511011": "511011 - First Line Supervisor Of Production And Operating Worker",
    "331099": "331099 - First Line Supervisor Of Protective Service Worker Other",
    "411011": "411011 - First Line Supervisor Of Retail Sales Workers",
    "331091": "331091 - First Line Supervisor Of Security Worker",
    "333031": "333031 - Fish And Game Warden",
    "453031": "453031 - Fishing And Hunting Worker",
    "532031": "532031 - Flight Attendant",
    "271023": "271023 - Floral Designer",
    "513091": "513091 - Food And Tobacco Roasting Baking And Drying Machine Operator And Tender",
    "513092": "513092 - Food Batchmaker",
    "513093": "513093 - Food Cooking Machine Operator And Tender",
    "359099": "359099 - Food Preparation And Serving Related Worker Other",
    "352021": "352021 - Food Preparation Worker",
    "513099": "513099 - Food Processing Worker Other",
    "353041": "353041 - Food Server Nonrestaurant",
    "119051": "119051 - Food Service Manager",
    "454011": "454011 - Forest And Conservation Worker",
    "514020": "514020 - Forming Machine Setter Operator And Tender Metal And Plastic",
    "131131": "131131 - Fundraiser",
    "119171": "119171 - Funeral Home Manager",
    "519051": "519051 - Furnace Kiln Oven Drier And Kettle Operator And Tender",
    "517021": "517021 - Furniture Finisher",
    "433041": "433041 - Gambling Cage Worker",
    "393010": "393010 - Gambling Services Worker",
    "111021": "111021 - General And Operations Manager",
    "19204X": "19204X - Geoscientist And Hydrologist Except Geographer",
    "472121": "472121 - Glazier",
    "452041": "452041 - Grader And Sorter Agricultural Product",
    "271024": "271024 - Graphic Designer",
    "514033": "514033 - Grinding Lapping Polishing And Buffing Machine Tool Setter Operator And Tender Metal And Plastic",
    "395012": "395012 - Hairdresser Hairstylist And Cosmetologist",
    "474041": "474041 - Hazardous Materials Removal Worker",
    "291299": "291299 - Healthcare Diagnosing Or Treating Practitioner Other",
    "211022": "211022 - Healthcare Social Worker",
    "499021": "499021 - Heating Air Conditioning And Refrigeration Mechanic And Installer",
    "493040": "493040 - Heavy Vehicle And Mobile Equipment Service Technician And Mechanic",
    "499098": "499098 - Helper Installation Maintenance And Repair Worker",
    "519198": "519198 - Helper Production Worker",
    "473010": "473010 - Helper Construction Trade",
    "474051": "474051 - Highway Maintenance Worker",
    "499031": "499031 - Home Appliance Repairer",
    "311121": "311121 - Home Health Aide",
    "359031": "359031 - Host And Hostess Restaurant Lounge And Coffee Shop",
    "434081": "434081 - Hotel Motel And Resort Desk Clerk",
    "434161": "434161 - Human Resources Assistant Except Payroll And Timekeeping",
    "113121": "113121 - Human Resources Manager",
    "131070": "131070 - Human Resources Worker",
    "49904X": "49904X - Industrial And Refractory Machinery Mechanic",
    "172110": "172110 - Industrial Engineer Including Health And Safety",
    "113051": "113051 - Industrial Production Manager",
    "537051": "537051 - Industrial Truck And Tractor Operator",
    "434199": "434199 - Information And Record Clerk Other",
    "151212": "151212 - Information Security Analyst",
    "519061": "519061 - Inspector Tester Sorter Sampler And Weigher",
    "472130": "472130 - Insulation Worker",
    "439041": "439041 - Insurance Claims And Policy Processing Clerk",
    "413021": "413021 - Insurance Sales Agent",
    "132053": "132053 - Insurance Underwriter",
    "271025": "271025 - Interior Designer",
    "273091": "273091 - Interpreter And Translator",
    "434111": "434111 - Interviewer Except Eligibility And Loan",
    "37201X": "37201X - Janitor And Building Cleaner",
    "519071": "519071 - Jeweler And Precious Stone And Metal Worker",
    "231020": "231020 - Judge Magistrate And Other Judicial Worker",
    "231012": "231012 - Judicial Law Clerk",
    "537062": "537062 - Laborer And Freight Stock And Material Mover Hand",
    "171012": "171012 - Landscape Architect",
    "373011": "373011 - Landscaping And Groundskeeping Worker",
    "516011": "516011 - Laundry And Dry Cleaning Worker",
    "231011": "231011 - Lawyer",
    "436012": "436012 - Legal Secretary And Administrative Assistant",
    "232099": "232099 - Legal Support Worker Other",
    "111031": "111031 - Legislator",
    "254022": "254022 - Librarian And Media Collections Specialist",
    "434121": "434121 - Library Assistant Clerical",
    "254031": "254031 - Library Technician",
    "292061": "292061 - Licensed Practical And Licensed Vocational Nurse",
    "191099": "191099 - Life Scientist Other",
    "434131": "434131 - Loan Interviewer And Clerk",
    "499094": "499094 - Locksmith And Safe Repairer",
    "534010": "534010 - Locomotive Engineer And Operator",
    "119081": "119081 - Lodging Manager",
    "454020": "454020 - Logging Worker",
    "131081": "131081 - Logistician",
    "537063": "537063 - Machine Feeder And Offbearer",
    "514041": "514041 - Machinist",
    "292035": "292035 - Magnetic Resonance Imaging Technologist",
    "372012": "372012 - Maids And Housekeeping Cleaner",
    "439051": "439051 - Mail Clerk And Mail Machine Operator Except Postal Service",
    "499071": "499071 - Maintenance And Repair Worker General",
    "499043": "499043 - Maintenance Worker Machinery",
    "131111": "131111 - Management Analyst",
    "119199": "119199 - Manager Other",
    "395092": "395092 - Manicurist And Pedicurist",
    "499095": "499095 - Manufactured Building And Mobile Home Installer",
    "172121": "172121 - Marine Engineer And Naval Architect",
    "131161": "131161 - Market Research Analyst And Marketing Specialist",
    "112021": "112021 - Marketing Manager",
    "211013": "211013 - Marriage And Family Therapist",
    "319011": "319011 - Massage Therapist",
    "172131": "172131 - Materials Engineer",
    "152021": "152021 - Mathematician",
    "172141": "172141 - Mechanical Engineer",
    "274099": "274099 - Media And Communication Equipment Worker Other",
    "273099": "273099 - Media And Communication Worker Other",
    "119111": "119111 - Medical And Health Services Manager",
    "319092": "319092 - Medical Assistant",
    "292072": "292072 - Medical Records Specialist",
    "191040": "191040 - Medical Scientist",
    "436013": "436013 - Medical Secretary And Administrative Assistant",
    "319094": "319094 - Medical Transcriptionist",
    "131121": "131121 - Meeting Convention And Event Planner",
    "211023": "211023 - Mental Health And Substance Abuse Social Worker",
    "211014": "211014 - Mental Health Counselor",
    "271026": "271026 - Merchandise Displayer And Window Trimmer",
    "514050": "514050 - Metal Furnace Operator Tender Pourer And Caster",
    "435041": "435041 - Meter Reader Utilities",
    "553010": "553010 - Military Enlisted Tactical Operations And Air Weapons Specialist",
    "551010": "551010 - Military Officer Special And Tactical Operations Leader",
    "554010": "554010 - Military Rank Not Specified",
    "499044": "499044 - Millwright",
    "172151": "172151 - Mining And Geological Engineer Including Mining Safety Engineer",
    "452090": "452090 - Miscellaneous Agricultural Worker",
    "474090": "474090 - Miscellaneous Construction And Related Worker",
    "292090": "292090 - Miscellaneous Health Technologist And Technician",
    "518090": "518090 - Miscellaneous Plant And System Operator",
    "193090": "193090 - Miscellaneous Social Scientist And Related Worker",
    "493090": "493090 - Miscellaneous Vehicle And Mobile Equipment Mechanic Installer And Repairer",
    "514060": "514060 - Model Maker And Patternmaker Metal And Plastic",
    "419010": "419010 - Model Demonstrator And Product Promoter",
    "514070": "514070 - Molder And Molding Machine Setter Operator And Tender Metal And Plastic",
    "519195": "519195 - Molder Shaper And Caster Except Metal And Plastic",
    "394031": "394031 - Mortician Undertaker And Funeral Arranger",
    "533099": "533099 - Motor Vehicle Operator Other",
    "272041": "272041 - Music Director And Composer",
    "272042": "272042 - Musician And Singer",
    "119121": "119121 - Natural Sciences Manager",
    "151244": "151244 - Network And Computer Systems Administrator",
    "434141": "434141 - New Accounts Clerk",
    "273023": "273023 - News Analyst Reporter And Journalist",
    "172161": "172161 - Nuclear Engineer",
    "29203X": "29203X - Nuclear Medicine Technologist And Medical Dosimetrist",
    "194051": "194051 - Nuclear Technician",
    "291151": "291151 - Nurse Anesthetist",
    "291161": "291161 - Nurse Midwife",
    "291171": "291171 - Nurse Practitioner",
    "311131": "311131 - Nursing Assistant",
    "195010": "195010 - Occupational Health And Safety Specialist And Technician",
    "291122": "291122 - Occupational Therapist",
    "312010": "312010 - Occupational Therapy Assistant And Aide",
    "439199": "439199 - Office And Administrative Support Worker Other",
    "439061": "439061 - Office Clerk General",
    "439071": "439071 - Office Machine Operator Except Computer",
    "152031": "152031 - Operations Research Analyst",
    "292081": "292081 - Optician Dispensing",
    "291041": "291041 - Optometrist",
    "434151": "434151 - Order Clerk",
    "31113X": "31113X - Orderly And Psychiatric Aide",
    "5120XX": "5120XX - Other Assembler And Fabricator",
    "21109X": "21109X - Other Community And Social Service Specialist",
    "27102X": "27102X - Other Designer",
    "17301X": "17301X - Other Drafter",
    "2590XX": "2590XX - Other Educational Instruction And Library Worker",
    "17302X": "17302X - Other Engineering Technologist And Technician",
    "3930XX": "3930XX - Other Entertainment Attendant And Related Worker",
    "4750XX": "4750XX - Other Extraction Worker",
    "1320XX": "1320XX - Other Financial Specialist",
    "37301X": "37301X - Other Grounds Maintenance Worker",
    "299000": "299000 - Other Healthcare Practitioner And Technical Occupation",
    "31909X": "31909X - Other Healthcare Support Worker",
    "49909X": "49909X - Other Installation Maintenance And Repair Worker",
    "1940XX": "1940XX - Other Life Physical And Social Science Technician",
    "51403X": "51403X - Other Machine Tool Setter Operator And Tender Metal And Plastic",
    "5371XX": "5371XX - Other Material Moving Worker",
    "1520XX": "1520XX - Other Mathematical Science Occupation",
    "514XXX": "514XXX - Other Metal Worker And Plastic Worker",
    "39509X": "39509X - Other Personal Appearance Worker",
    "2912XX": "2912XX - Other Physician",
    "51919X": "51919X - Other Production Equipment Operator And Tender",
    "5191XX": "5191XX - Other Production Worker",
    "33909X": "33909X - Other Protective Service Worker",
    "19303X": "19303X - Other Psychologist",
    "5340XX": "5340XX - Other Rail Transportation Worker",
    "2530XX": "2530XX - Other Teacher And Instructor",
    "51609X": "51609X - Other Textile Apparel And Furnishings Worker",
    "5360XX": "5360XX - Other Transportation Worker",
    "5170XX": "5170XX - Other Woodworker",
    "519111": "519111 - Packaging And Filling Machine Operator And Tender",
    "537064": "537064 - Packer And Packager Hand",
    "472140": "472140 - Painter And Paperhanger",
    "519120": "519120 - Painting Worker",
    "519196": "519196 - Paper Goods Machine Setter Operator And Tender",
    "232011": "232011 - Paralegal And Legal Assistant",
    "292043": "292043 - Paramedic",
    "536021": "536021 - Parking Attendant",
    "333041": "333041 - Parking Enforcement Worker",
    "412022": "412022 - Parts Salesperson",
    "536061": "536061 - Passenger Attendant",
    "433051": "433051 - Payroll And Timekeeping Clerk",
    "399099": "399099 - Personal Care And Service Worker Other",
    "132052": "132052 - Personal Financial Advisor",
    "119179": "119179 - Personal Service Manager Other",
    "372021": "372021 - Pest Control Worker",
    "172171": "172171 - Petroleum Engineer",
    "291051": "291051 - Pharmacist",
    "319095": "319095 - Pharmacy Aide",
    "292052": "292052 - Pharmacy Technician",
    "319097": "319097 - Phlebotomist",
    "274021": "274021 - Photographer",
    "519151": "519151 - Photographic Process Worker And Processing Machine Operator",
    "192099": "192099 - Physical Scientist Other",
    "291123": "291123 - Physical Therapist",
    "312020": "312020 - Physical Therapist Assistant And Aide",
    "291071": "291071 - Physician Assistant",
    "472151": "472151 - Pipelayer",
    "472161": "472161 - Plasterer And Stucco Mason",
    "472152": "472152 - Plumber Pipefitter And Steamfitter",
    "291081": "291081 - Podiatrist",
    "333050": "333050 - Police Officer",
    "435051": "435051 - Postal Service Clerk",
    "435052": "435052 - Postal Service Mail Carrier",
    "435053": "435053 - Postal Service Mail Sorter Processor And Processing Machine Operator",
    "119131": "119131 - Postmaster And Mail Superintendent",
    "251000": "251000 - Postsecondary Teacher",
    "518010": "518010 - Power Plant Operator Distributor And Dispatcher",
    "499060": "499060 - Precision Instrument And Equipment Repairer",
    "515111": "515111 - Prepress Technician And Worker",
    "252010": "252010 - Preschool And Kindergarten Teacher",
    "516021": "516021 - Presser Textile Garment And Related Material",
    "515113": "515113 - Print Binding And Finishing Worker",
    "515112": "515112 - Printing Press Operator",
    "339021": "339021 - Private Detective And Investigator",
    "211092": "211092 - Probation Officer And Correctional Treatment Specialist",
    "433061": "433061 - Procurement Clerk",
    "272012": "272012 - Producer And Director",
    "435061": "435061 - Production Planning And Expediting Clerk",
    "131082": "131082 - Project Management Specialist",
    "439081": "439081 - Proofreader And Copy Marker",
    "132020": "132020 - Property Appraiser And Assessor",
    "119141": "119141 - Property Real Estate And Community Association Manager",
    "292053": "292053 - Psychiatric Technician",
    "112030": "112030 - Public Relations And Fundraising Manager",
    "273031": "273031 - Public Relations Specialist",
    "435031": "435031 - Public Safety Telecommunicator",
    "537070": "537070 - Pumping Station Operator",
    "131023": "131023 - Purchasing Agent Except Wholesale Retail And Farm Products",
    "113061": "113061 - Purchasing Manager",
    "291124": "291124 - Radiation Therapist",
    "492020": "492020 - Radio And Telecommunications Equipment Installer And Repairer",
    "292034": "292034 - Radiologic Technologist And Technician",
    "291224": "291224 - Radiologist",
    "474061": "474061 - Rail Track Laying And Maintenance Equipment Operator",
    "534031": "534031 - Railroad Conductor And Yardmaster",
    "419020": "419020 - Real Estate Broker And Sales Agent",
    "434171": "434171 - Receptionist And Information Clerk",
    "399032": "399032 - Recreation Worker",
    "291125": "291125 - Recreational Therapist",
    "537081": "537081 - Refuse And Recyclable Material Collector",
    "291141": "291141 - Registered Nurse",
    "211015": "211015 - Rehabilitation Counselor",
    "472171": "472171 - Reinforcing Iron And Rebar Worker",
    "212099": "212099 - Religious Worker Other",
    "434181": "434181 - Reservation And Transportation Ticket Agent And Travel Clerk",
    "399041": "399041 - Residential Advisor",
    "291126": "291126 - Respiratory Therapist",
    "412031": "412031 - Retail Salesperson",
    "499096": "499096 - Rigger",
    "472181": "472181 - Roofer",
    "475071": "475071 - Roustabout Oil And Gas",
    "535011": "535011 - Sailor And Marine Oiler",
    "419099": "419099 - Sales And Related Worker Other",
    "419031": "419031 - Sales Engineer",
    "112022": "112022 - Sales Manager",
    "413091": "413091 - Sales Representative Of Services Except Advertising Insurance Financial Services And Travel",
    "414010": "414010 - Sales Representatives Wholesale And Manufacturing",
    "517041": "517041 - Sawing Machine Setter Operator And Tender Wood",
    "533051": "533051 - School Bus Driver",
    "339094": "339094 - School Bus Monitor",
    "193034": "193034 - School Psychologist",
    "252030": "252030 - Secondary School Teacher",
    "436014": "436014 - Secretary And Administrative Assistant Except Legal Medical And Executive",
    "413031": "413031 - Securities Commodities And Financial Services Sales Agent",
    "492098": "492098 - Security And Fire Alarm Systems Installer",
    "339030": "339030 - Security Guard And Gambling Surveillance Officer",
    "474071": "474071 - Septic Tank Servicer And Sewer Pipe Cleaner",
    "516031": "516031 - Sewing Machine Operator",
    "472211": "472211 - Sheet Metal Worker",
    "535020": "535020 - Ship And Boat Captain And Operator",
    "535031": "535031 - Ship Engineer",
    "435071": "435071 - Shipping Receiving And Inventory Clerk",
    "516040": "516040 - Shoe And Leather Worker",
    "533053": "533053 - Shuttle Driver And Chauffeur",
    "395094": "395094 - Skincare Specialist",
    "493050": "493050 - Small Engine Mechanic",
    "119151": "119151 - Social And Community Service Manager",
    "211093": "211093 - Social And Human Service Assistant",
    "194061": "194061 - Social Science Research Assistant",
    "211029": "211029 - Social Worker Other",
    "193041": "193041 - Sociologist",
    "151252": "151252 - Software Developer",
    "151253": "151253 - Software Quality Assurance Analyst And Tester",
    "472231": "472231 - Solar Photovoltaic Installer",
    "252050": "252050 - Special Education Teacher",
    "291127": "291127 - Speech Language Pathologist",
    "518021": "518021 - Stationary Engineer And Boiler Operator",
    "439111": "439111 - Statistical Assistant",
    "152041": "152041 - Statistician",
    "537065": "537065 - Stocker And Order Filler",
    "472221": "472221 - Structural Iron And Steel Worker",
    "512041": "512041 - Structural Metal Fabricator And Fitter",
    "211011": "211011 - Substance Abuse And Behavioral Disorder Counselor",
    "391000": "391000 - Supervisor Of Personal Care And Service Worker",
    "531000": "531000 - Supervisor Of Transportation And Material Moving Worker",
    "291240": "291240 - Surgeon",
    "292055": "292055 - Surgical Technologist",
    "193022": "193022 - Survey Researcher",
    "173031": "173031 - Surveying And Mapping Technician",
    "171020": "171020 - Surveyor Cartographer And Photogrammetrist",
    "432011": "432011 - Switchboard Operator Including Answering Service",
    "516050": "516050 - Tailor Dressmaker And Sewer",
    "132081": "132081 - Tax Examiner And Collector And Revenue Agent",
    "132082": "132082 - Tax Preparer",
    "533054": "533054 - Taxi Driver",
    "259040": "259040 - Teaching Assistant",
    "273042": "273042 - Technical Writer",
    "499052": "499052 - Telecommunications Line Installer And Repairer",
    "419041": "419041 - Telemarketer",
    "432021": "432021 - Telephone Operator",
    "274030": "274030 - Television Video And Film Camera Operator And Editor",
    "433071": "433071 - Teller",
    "516060": "516060 - Textile Machine Setter Operator And Tender",
    "291129": "291129 - Therapist Other",
    "519197": "519197 - Tire Builder",
    "232093": "232093 - Title Examiner Abstractor And Searcher",
    "514111": "514111 - Tool And Die Maker",
    "397010": "397010 - Tour And Travel Guide",
    "113131": "113131 - Training And Development Manager",
    "131151": "131151 - Training And Development Specialist",
    "533052": "533052 - Transit And Intercity Bus Driver",
    "536051": "536051 - Transportation Inspector",
    "339093": "339093 - Transportation Security Screener",
    "536030": "536030 - Transportation Service Attendant",
    "113071": "113071 - Transportation Storage And Distribution Manager",
    "413041": "413041 - Travel Agent",
    "373013": "373013 - Tree Trimmer And Pruner",
    "253041": "253041 - Tutor",
    "272023": "272023 - Umpire Referee And Other Sports Official",
    "475040": "475040 - Underground Mining Machine Operator",
    "999999": "999999 - Unemployed No Work Experience",
    "516093": "516093 - Upholsterer",
    "193051": "193051 - Urban And Regional Planner",
    "393031": "393031 - Usher Lobby Attendant And Ticket Taker",
    "291131": "291131 - Veterinarian",
    "319096": "319096 - Veterinary Assistant And Laboratory Animal Caretaker",
    "292056": "292056 - Veterinary Technologist And Technician",
    "353031": "353031 - Waiter Or Waitress",
    "518031": "518031 - Water And Wastewater Treatment Plant And System Operator",
    "151255": "151255 - Web And Digital Interface Designer",
    "151254": "151254 - Web Developer",
    "435111": "435111 - Weigher Measurer Checker And Sampler Recordkeeping",
    "514120": "514120 - Welding Soldering And Brazing Worker",
    "131022": "131022 - Wholesale And Retail Buyer Except Farm Products",
    "499081": "499081 - Wind Turbine Service Technician",
    "517042": "517042 - Woodworking Machine Setter Operator And Tender Except Sawing",
    "439022": "439022 - Word Processor And Typist",
    "273043": "273043 - Writer And Author"
  },
  "ProfileKYCVendorsAndCounterparties": {
    "SELF": "Self",
    "MERCHANTS_SUPPLIERS": "Merchants/Suppliers",
    "CUSTOMERS": "Customers",
    "EMPLOYEES": "Employees",
    "CONTRACTORS": "Contractors",
    "FRIENDS": "Friends",
    "FAMILY": "Family"
  },
  "ProfileCorporateKYCPrimaryBusiness": {
    "SOFTWARE": "Software",
    "ATM": "ATM",
    "BROKER": "Broker",
    "CHARITY": "Charity",
    "COMMODITIES": "Commodities",
    "DEFI_EXCHANGE": "DeFi Exchange",
    "GOVERNMENT_FOREIGN": "Government (Foreign)",
    "GOVERNMENT_US": "Government (US)",
    "HNWI": "HNWI",
    "INSURANCE": "Insurance",
    "ADVISOR": "Advisor",
    "LOAN": "Loan",
    "MINER": "Miner",
    "NFT": "NFT",
    "NON_BANK_CUSTODIAN": "Non-Bank Custodian",
    "PENSION": "Pension",
    "WHV": "WHV",
    "POOLED_INVESTMENT": "Pooled Investment",
    "PROP_TRADING": "Prop Trading",
    "PUBLIC": "Public",
    "SPV": "SPV",
    "STATE_FOREIGN": "State (Foreign)",
    "STATE_US": "State (US)",
    "SUPRANATIONAL_BODY": "Supranational Body",
    "PAYMENT_PROCESSOR": "Payment Processor",
    "TOKEN_PROJECT": "Token Project",
    "TRUST_PERSONAL": "Trust (Personal)",
    "TRUST_CORP": "Trust (Corp)",
    "BANK_US": "Bank (US)",
    "BANK_FOREIGN": "Bank (Foreign)",
    "CRYPTO_MSB_US": "Crypto MSB (US)",
    "CRYPTO_MSB_FOREIGN": "Crypto MSB (Foreign)",
    "NON_CRYPTO_MSB_US": "Non-Crypto MSB (US)",
    "NON_CRYPTO_MSB_FOREIGN": "Non-Crypto MSB (Foreign)",
    "WHOLESALER_DURABLE": "Wholesaler of Durable Goods",
    "WHOLESALER_NON_DURABLE": "Wholesaler of Non-Durable Goods",
    "RETAILER_DURABLE": "Retailer of Durable Goods",
    "RETAILER_NON_DURABLE": "Retailer of Non-Durable Goods",
    "CONSTRUCTION_TRADES": "Construction Trades",
    "PROFESSIONAL_SERVICES": "Professional Services",
    "OTHER": "Other"
  },
  "WithdrawalType": {
    "FIAT": "FIAT",
    "CRYPTO": "CRYPTO"
  },
  "ProfileCorporateKYCEngageInActivities": {
    "NONE": "None",
    "ADULT_ENTERTAINMENT": "Adult Entertainment",
    "DRUGS": "Drugs",
    "FIREARMS": "Firearms",
    "GAMBLING": "Gambling",
    "MARIJUANA": "Marijuana",
    "TUMBLING": "Tumbling"
  },
  "ProfileCorporateKYCRegulatedStatus": {
    "REGULATED": "Regulated",
    "REGISTERED": "Registered",
    "LICENSED": "Licensed",
    "NONE": "None",
    "NOT_REQUIRED": "Not Required"
  },
  "ProfileCorporateKYCControlExemptionReason": {
    "REGULATED": "Regulated",
    "PUBLICLY_TRADED": "Publicly Traded",
    "PUBLIC_SUBSIDIARY": "Public Subsidiary",
    "PUBLIC_ACCOUNTING": "Public Accounting",
    "INSURANCE": "Insurance",
    "GOVERNMENT_AGENCY": "Government Agency",
    "BANK_HOLDING": "Bank Holding",
    "SAVINGS_LOAN": "Savings Loan",
    "FMU": "FMU",
    "FOREIGN_PRIVATE_BANK": "Foreign Private Bank",
    "FOREIGN_INSTITUTION": "Foreign Institution",
    "ISSUER": "Issuer",
    "INVESTMENT": "Investment",
    "COMMODITIES": "Commodities",
    "POOLED_INVESTMENT": "Pooled Investment",
    "NON_GOVERNMENT_SUBDIVISION": "Non-Government Subdivision",
    "NON_ENTITY": "Non-Entity",
    "NONE": "None"
  },
  "CounterPartyProfileFIATUSLineOfBusiness": {
    "ARTS_AND_ANTIQUES": "Arts and Antiques",
    "AGRICULTURE": "Agriculture",
    "AUDIT_VIDEO": "Audit Video",
    "AUTOMOTIVE": "Automotive",
    "BANK_CREDIT_UNION": "Bank/Credit Union",
    "BIOTECH_PHARMACEUTICAL": "Biotech/Pharmaceutical",
    "BOOKSELLER": "Bookseller",
    "CONSTRUCTION": "Construction",
    "CASINOS_GAMBLING": "Casinos/Gambling",
    "CLOTHING": "Clothing",
    "CONSULTING_PROFESSIONAL_SERVICES": "Consulting/Professional Services",
    "CRYPTOCURRENCY": "Cryptocurrency",
    "ECIGARETTES_TOBACCO": "E-cigarettes/Tobacco",
    "ENERGY_CHEMICAL_FUEL": "Energy/Chemical/Fuel",
    "ENGINEERING": "Engineering",
    "ADULT_ENTERTAINMENT": "Adult Entertainment",
    "FINANCIAL_AND_CORPORATE_SERVICES": "Financial and Corporate Services",
    "FOOD_AND_BEVERAGE": "Food and Beverage",
    "FREIGHT_MARINE_SHIPPING_SERVICES": "Freight/Marine/Shipping Services",
    "GIFTWARE_SEASONAL": "Giftware/Seasonal",
    "GOVERNMENT_PUBLIC_SERVICES": "Government/Public Services",
    "HIGH_TECH_SOFTWARE_TELECOMS": "High Tech/Software/Telecoms",
    "HOSPITALITY": "Hospitality",
    "HOUSEHOLD_GOOD_FURNITURE": "Household Goods/Furniture",
    "HUMAN_RESOURCE_SERVICES": "Human Resource Services",
    "INDUSTRIAL_EQUIPMENT": "Industrial Equipment",
    "INFORMATION_TECHNOLOGY": "Information Technology",
    "INSURANCE": "Insurance",
    "JEWELLERY_OPTICAL": "Jewellery/Optical",
    "LAW": "Law",
    "MANUFACTURING": "Manufacturing",
    "MARKETING": "Marketing",
    "MEDIA_PUBLISHING": "Media/Publishing",
    "MEDICAL_HEALTHCARE": "Medical/Healthcare",
    "MEDICAL_TOURISM": "Medical Tourism",
    "MINING": "Mining",
    "MONEY_SERVICE_BUSINESS": "Money Service Business",
    "NON_PROFIT_CHARITY": "Non-Profit/Charity",
    "ONLINE_RETAIL": "Online Retail",
    "PAYROLL": "Payroll",
    "PENSION": "Pension",
    "PERSONAL_CARE_PRODUCTS": "Personal Care Products",
    "PHOTOGRAPHY": "Photography",
    "REAL_ESTATE": "Real Estate",
    "RECREATIONAL_ACTIVITIES": "Recreational Activities",
    "RELIGIOUS_ORGANISATION": "Religious Organisation",
    "RETAIL": "Retail",
    "SECURITY": "Security",
    "SPORTING_RECREATIONAL_PRODUCTS": "Sporting/Recreational Products",
    "TRANSPORT": "Transport",
    "UNIVERSITY_EDUCATION": "University/Education",
    "UTILITIES": "Utilities",
    "WASTE_MANAGEMENT": "Waste Management",
    "WINE_LIQUOR": "Wine/Liquor",
    "TECHNICAL_SUPPORT": "Technical Support",
    "OTHER": "Other"
  },
  "CounterPartyProfileFIATUSRelationshipToCustomer": {
    "SPOUSE": "Spouse",
    "EX_SPOUSE": "Ex-Spouse",
    "CHILDREN": "Children",
    "PARENT": "Parent",
    "SIBLING": "Sibling",
    "RELATIVE": "Relative",
    "SELF": "Self",
    "FRIEND": "Friend",
    "BUSINESS_PARTNER": "Business Partner",
    "CUSTOMER": "Customer",
    "EMPLOYEE": "Employee",
    "BRANCH_OFFICE": "Branch Office",
    "SUBSIDIARY_COMPANY": "Subsidiary Company",
    "HOLDING_COMPANY": "Holding Company",
    "SUPPLIER": "Supplier",
    "CREDITOR": "Creditor",
    "DEBTOR": "Debtor",
    "FRANCHISEE": "Franchisee",
    "NOT_RELATED": "Not Related"
  },
  "CounterPartyProfileFIATBSLineOfBusiness": {
    "ARTS_AND_ANTIQUES": "Arts and Antiques",
    "AGRICULTURE": "Agriculture",
    "AUDIT_VIDEO": "Audit Video",
    "AUTOMOTIVE": "Automotive",
    "BANK_CREDIT_UNION": "Bank/Credit Union",
    "BIOTECH_PHARMACEUTICAL": "Biotech/Pharmaceutical",
    "BOOKSELLER": "Bookseller",
    "CONSTRUCTION": "Construction",
    "CASINOS_GAMBLING": "Casinos/Gambling",
    "CLOTHING": "Clothing",
    "CONSULTING_PROFESSIONAL_SERVICES": "Consulting/Professional Services",
    "CRYPTOCURRENCY": "Cryptocurrency",
    "ECIGARETTES_TOBACCO": "E-cigarettes/Tobacco",
    "ENERGY_CHEMICAL_FUEL": "Energy/Chemical/Fuel",
    "ENGINEERING": "Engineering",
    "ADULT_ENTERTAINMENT": "Adult Entertainment",
    "FINANCIAL_AND_CORPORATE_SERVICES": "Financial and Corporate Services",
    "FOOD_AND_BEVERAGE": "Food and Beverage",
    "FREIGHT_MARINE_SHIPPING_SERVICES": "Freight/Marine/Shipping Services",
    "GIFTWARE_SEASONAL": "Giftware/Seasonal",
    "GOVERNMENT_PUBLIC_SERVICES": "Government/Public Services",
    "HIGH_TECH_SOFTWARE_TELECOMS": "High Tech/Software/Telecoms",
    "HOSPITALITY": "Hospitality",
    "HOUSEHOLD_GOOD_FURNITURE": "Household Goods/Furniture",
    "HUMAN_RESOURCE_SERVICES": "Human Resource Services",
    "INDUSTRIAL_EQUIPMENT": "Industrial Equipment",
    "INFORMATION_TECHNOLOGY": "Information Technology",
    "INSURANCE": "Insurance",
    "JEWELLERY_OPTICAL": "Jewellery/Optical",
    "LAW": "Law",
    "MANUFACTURING": "Manufacturing",
    "MARKETING": "Marketing",
    "MEDIA_PUBLISHING": "Media/Publishing",
    "MEDICAL_HEALTHCARE": "Medical/Healthcare",
    "MEDICAL_TOURISM": "Medical Tourism",
    "MINING": "Mining",
    "MONEY_SERVICE_BUSINESS": "Money Service Business",
    "NON_PROFIT_CHARITY": "Non-Profit/Charity",
    "ONLINE_RETAIL": "Online Retail",
    "PAYROLL": "Payroll",
    "PENSION": "Pension",
    "PERSONAL_CARE_PRODUCTS": "Personal Care Products",
    "PHOTOGRAPHY": "Photography",
    "REAL_ESTATE": "Real Estate",
    "RECREATIONAL_ACTIVITIES": "Recreational Activities",
    "RELIGIOUS_ORGANISATION": "Religious Organisation",
    "RETAIL": "Retail",
    "SECURITY": "Security",
    "SPORTING_RECREATIONAL_PRODUCTS": "Sporting/Recreational Products",
    "TRANSPORT": "Transport",
    "UNIVERSITY_EDUCATION": "University/Education",
    "UTILITIES": "Utilities",
    "WASTE_MANAGEMENT": "Waste Management",
    "WINE_LIQUOR": "Wine/Liquor",
    "TECHNICAL_SUPPORT": "Technical Support",
    "OTHER": "Other"
  },
  "CounterPartyProfileFIATBSRelationshipToCustomer": {
    "SPOUSE": "Spouse",
    "EX_SPOUSE": "Ex-Spouse",
    "CHILDREN": "Children",
    "PARENT": "Parent",
    "SIBLING": "Sibling",
    "RELATIVE": "Relative",
    "SELF": "Self",
    "FRIEND": "Friend",
    "BUSINESS_PARTNER": "Business Partner",
    "CUSTOMER": "Customer",
    "EMPLOYEE": "Employee",
    "BRANCH_OFFICE": "Branch Office",
    "SUBSIDIARY_COMPANY": "Subsidiary Company",
    "HOLDING_COMPANY": "Holding Company",
    "SUPPLIER": "Supplier",
    "CREDITOR": "Creditor",
    "DEBTOR": "Debtor",
    "FRANCHISEE": "Franchisee",
    "NOT_RELATED": "Not Related"
  },
  "RequestExchangeAction": {
    "FIX_DESTINATION": "Fix Destination",
    "FIX_SOURCE": "Fix Source"
  },
  "CounterPartyIntermediaryFIATCNIntermediaryType": {
    "FIAT_US": "FIAT US",
    "FIAT_CA": "FIAT CA"
  },
  "RequestIndividualIndividualType": {
    "OFFICER": "Officer",
    "BENEFICIAL_OWNER": "Beneficial Owner",
    "CONTROL_PERSON": "Control Person",
    "AUTHORIZED_PERSON": "Authorized Person"
  },
  "RequestIndividualUsResidencyStatus": {
    "US_CITIZEN": "US Citizen",
    "RESIDENT_ALIEN": "Resident Alien",
    "NON_RESIDENT_ALIEN": "Non-Resident Alien"
  },
  "WithdrawalCryptoStatus": {
    "REQUESTED": "Requested",
    "REJECTED": "Rejected",
    "EXPIRED": "Expired",
    "ACCEPTED": "Accepted",
    "EXECUTED": "Executed",
    "CANCELLED": "Cancelled"
  },
  "WithdrawalCryptoWithdrawalRail": {
    "ACH": "ACH",
    "FEDWIRE": "Fedwire",
    "SWIFT": "SWIFT",
    "CRYPTO": "Crypto",
    "EFT": "EFT"
  },
  "WithdrawalCryptoPurpose": {
    "PERSONAL_ACCOUNT": "Personal Account",
    "FAMILY": "Family",
    "INSURANCE": "Insurance",
    "INVESTMENT": "Investment",
    "REAL_ESTATE": "Real Estate",
    "TUITION": "Tuition",
    "MEDICAL": "Medical",
    "TRAVEL": "Travel",
    "TRADE_TRANSACTIONS": "Trade Transactions",
    "UTILITY": "Utility",
    "TAX": "Tax",
    "LOAN": "Loan",
    "BILLS": "Bills",
    "PAYROLL": "Payroll",
    "TELECOM": "Telecom",
    "INTELLECTUAL_PROPERTY": "Intellectual Property",
    "OTHER_BUSINESS_SERVICES": "Other Business Services",
    "CHARITABLE_DONATIONS": "Charitable Donations",
    "MORTGAGE": "Mortgage",
    "EXPENSES_REIMBURSEMENT": "Expenses Reimbursement",
    "PROFESSIONAL_SERVICES": "Professional Services",
    "MARKETING": "Marketing",
    "RENTAL_PROPERTY": "Rental Property",
    "OTHER": "Other"
  },
  "IndividualIndividualType": {
    "BENEFICIAL_OWNER": "Beneficial Owner",
    "CONTROL_PERSON": "Control Person"
  },
  "IndividualUsResidencyStatus": {
    "US_CITIZEN": "US Citizen",
    "RESIDENT_ALIEN": "Resident Alien",
    "NON_RESIDENT_ALIEN": "Non-Resident Alien"
  },
  "WithdrawalSwiftStatus": {
    "REQUESTED": "Requested",
    "REJECTED": "Rejected",
    "EXPIRED": "Expired",
    "ACCEPTED": "Accepted",
    "EXECUTED": "Executed",
    "CANCELLED": "Cancelled"
  },
  "WithdrawalSwiftWithdrawalRail": {
    "ACH": "ACH",
    "FEDWIRE": "Fedwire",
    "SWIFT": "SWIFT",
    "CRYPTO": "Crypto",
    "EFT": "EFT"
  },
  "WithdrawalSwiftPurpose": {
    "PERSONAL_ACCOUNT": "Personal Account",
    "FAMILY": "Family",
    "INSURANCE": "Insurance",
    "INVESTMENT": "Investment",
    "REAL_ESTATE": "Real Estate",
    "TUITION": "Tuition",
    "MEDICAL": "Medical",
    "TRAVEL": "Travel",
    "TRADE_TRANSACTIONS": "Trade Transactions",
    "UTILITY": "Utility",
    "TAX": "Tax",
    "LOAN": "Loan",
    "BILLS": "Bills",
    "PAYROLL": "Payroll",
    "TELECOM": "Telecom",
    "INTELLECTUAL_PROPERTY": "Intellectual Property",
    "OTHER_BUSINESS_SERVICES": "Other Business Services",
    "CHARITABLE_DONATIONS": "Charitable Donations",
    "MORTGAGE": "Mortgage",
    "EXPENSES_REIMBURSEMENT": "Expenses Reimbursement",
    "PROFESSIONAL_SERVICES": "Professional Services",
    "MARKETING": "Marketing",
    "RENTAL_PROPERTY": "Rental Property",
    "OTHER": "Other"
  },
  "CounterPartyIntermediaryFIATJPIntermediaryType": {
    "FIAT_US": "FIAT US",
    "FIAT_CA": "FIAT CA"
  },
  "InstructionSwiftInstructionType": {
    "CRYPTO": "Crypto",
    "ACH": "ACH",
    "FEDWIRE": "Fedwire"
  },
  "IndividualFieldErrorFieldName": {
    "id": "ID",
    "person_role": "Person Role",
    "person_status": "Person Status",
    "first_name": "First Name",
    "middle_name": "Middle Name",
    "last_name": "Last Name",
    "email_address": "Email Address",
    "mailing_address.unit_number": "Mailing Address Unit Number",
    "mailing_address.address_line1": "Mailing Address Line 1",
    "mailing_address.address_line2": "Mailing Address Line 2",
    "mailing_address.address_line3": "Mailing Address Line 3",
    "mailing_address.city": "Mailing Address City",
    "mailing_address.state": "Mailing Address State",
    "mailing_address.postal_code": "Mailing Address Postal Code",
    "mailing_address.country_code": "Mailing Address Country Code",
    "telephone_number": "Telephone Number",
    "tax_reference_number": "Tax Reference Number",
    "passport_number": "Passport Number",
    "nationality": "Nationality",
    "date_of_birth": "Date of Birth",
    "percentage_ownership": "Percentage Ownership",
    "title": "Title",
    "us_residency_status": "US Residency Status"
  },
  "IndividualFieldErrorFieldStatus": {
    "INCOMPLETE": "Incomplete",
    "READY_FOR_SUBMISSION": "Ready for Submission",
    "CHANGES_REQUESTED": "Changes Requested",
    "APPROVED": "Approved"
  },
  "DocumentErrorStatus": {
    "MISSING": "Missing",
    "SUBMITTED": "Submitted",
    "CHANGES_REQUESTED": "Changes Requested",
    "REJECTED": "Rejected",
    "APPROVED": "Approved"
  },
  "DocumentErrorDocument": {
    "DRIVERS_LICENCE_FRONT": "Driver's Licence Front",
    "DRIVERS_LICENCE_BACK": "Driver's Licence Back",
    "GOVERNMENT_ID_FRONT": "Government ID Front",
    "GOVERNMENT_ID_BACK": "Government ID Back",
    "PASSPORT": "Passport",
    "UTILITY_BILL": "Utility Bill",
    "FINANCIAL_STATEMENT": "Financial Statement",
    "LEASE_AGREEMENT": "Lease Agreement",
    "SOCIAL_SECURITY_CARD": "Social Security Card",
    "POWER_OF_ATTORNEY": "Power of Attorney",
    "ANNUAL_REPORT": "Annual Report",
    "INCORPORATION_DOCUMENTS": "Incorporation Documents",
    "PARTNERSHIP_AGREEMENT": "Partnership Agreement",
    "LLC_AGREEMENT": "LLC Agreement",
    "LAYER2_ACCOUNT_AGREEMENT": "Layer2 Account Agreement",
    "ACCOUNT_AGREEMENT": "Account Agreement"
  },
  "CounterPartyFIATUSCounterpartyType": {
    "FIAT_US": "FIAT US",
    "FIAT_US_LINKED": "FIAT US Linked",
    "FIAT_CA": "FIAT CA",
    "FIAT_CA_LINKED": "FIAT CA Linked",
    "CRYPTO": "Crypto"
  },
  "CounterPartyFIATUSSupportedRails": {
    "ACH": "ACH",
    "FEDWIRE": "Fedwire",
    "SWIFT": "SWIFT"
  },
  "CounterPartyFIATBSCounterpartyType": {
    "FIAT_US": "FIAT US",
    "FIAT_US_LINKED": "FIAT US Linked",
    "FIAT_CA": "FIAT CA",
    "FIAT_CA_LINKED": "FIAT CA Linked",
    "CRYPTO": "Crypto"
  },
  "CounterPartyFIATBSSupportedRails": {
    "ACH": "ACH",
    "SWIFT": "SWIFT"
  },
  "ApplicationCorporationStatus": {
    "INCOMPLETE": "Incomplete",
    "READY_FOR_SUBMISSION": "Ready for Submission",
    "SUBMITTED": "Submitted",
    "PROCESSING": "Processing",
    "CHANGES_REQUESTED": "Changes Requested",
    "REJECTED": "Rejected",
    "APPROVED": "Approved"
  },
  "ApplicationCorporationApplicationType": {
    "INDIVIDUAL": "Individual",
    "CORPORATION": "Corporation"
  },
  "CounterPartyProfileFIATCNLineOfBusiness": {
    "ARTS_AND_ANTIQUES": "Arts and Antiques",
    "AGRICULTURE": "Agriculture",
    "AUDIT_VIDEO": "Audit Video",
    "AUTOMOTIVE": "Automotive",
    "BANK_CREDIT_UNION": "Bank/Credit Union",
    "BIOTECH_PHARMACEUTICAL": "Biotech/Pharmaceutical",
    "BOOKSELLER": "Bookseller",
    "CONSTRUCTION": "Construction",
    "CASINOS_GAMBLING": "Casinos/Gambling",
    "CLOTHING": "Clothing",
    "CONSULTING_PROFESSIONAL_SERVICES": "Consulting/Professional Services",
    "CRYPTOCURRENCY": "Cryptocurrency",
    "ECIGARETTES_TOBACCO": "E-cigarettes/Tobacco",
    "ENERGY_CHEMICAL_FUEL": "Energy/Chemical/Fuel",
    "ENGINEERING": "Engineering",
    "ADULT_ENTERTAINMENT": "Adult Entertainment",
    "FINANCIAL_AND_CORPORATE_SERVICES": "Financial and Corporate Services",
    "FOOD_AND_BEVERAGE": "Food and Beverage",
    "FREIGHT_MARINE_SHIPPING_SERVICES": "Freight/Marine Shipping Services",
    "GIFTWARE_SEASONAL": "Giftware/Seasonal",
    "GOVERNMENT_PUBLIC_SERVICES": "Government/Public Services",
    "HIGH_TECH_SOFTWARE_TELECOMS": "High Tech/Software/Telecoms",
    "HOSPITALITY": "Hospitality",
    "HOUSEHOLD_GOOD_FURNITURE": "Household Goods/Furniture",
    "HUMAN_RESOURCE_SERVICES": "Human Resource Services",
    "INDUSTRIAL_EQUIPMENT": "Industrial Equipment",
    "INFORMATION_TECHNOLOGY": "Information Technology",
    "INSURANCE": "Insurance",
    "JEWELLERY_OPTICAL": "Jewellery/Optical",
    "LAW": "Law",
    "MANUFACTURING": "Manufacturing",
    "MARKETING": "Marketing",
    "MEDIA_PUBLISHING": "Media/Publishing",
    "MEDICAL_HEALTHCARE": "Medical/Healthcare",
    "MEDICAL_TOURISM": "Medical Tourism",
    "MINING": "Mining",
    "MONEY_SERVICE_BUSINESS": "Money Service Business",
    "NON_PROFIT_CHARITY": "Non-Profit/Charity",
    "ONLINE_RETAIL": "Online Retail",
    "PAYROLL": "Payroll",
    "PENSION": "Pension",
    "PERSONAL_CARE_PRODUCTS": "Personal Care Products",
    "PHOTOGRAPHY": "Photography",
    "REAL_ESTATE": "Real Estate",
    "RECREATIONAL_ACTIVITIES": "Recreational Activities",
    "RELIGIOUS_ORGANISATION": "Religious Organisation",
    "RETAIL": "Retail",
    "SECURITY": "Security",
    "SPORTING_RECREATIONAL_PRODUCTS": "Sporting/Recreational Products",
    "TRANSPORT": "Transport",
    "UNIVERSITY_EDUCATION": "University Education",
    "UTILITIES": "Utilities",
    "WASTE_MANAGEMENT": "Waste Management",
    "WINE_LIQUOR": "Wine/Liquor",
    "TECHNICAL_SUPPORT": "Technical Support",
    "OTHER": "Other"
  },
  "CounterPartyProfileFIATCNRelationshipToCustomer": {
    "SPOUSE": "Spouse",
    "EX_SPOUSE": "Ex-Spouse",
    "CHILDREN": "Children",
    "PARENT": "Parent",
    "SIBLING": "Sibling",
    "RELATIVE": "Relative",
    "SELF": "Self",
    "FRIEND": "Friend",
    "BUSINESS_PARTNER": "Business Partner",
    "CUSTOMER": "Customer",
    "EMPLOYEE": "Employee",
    "BRANCH_OFFICE": "Branch Office",
    "SUBSIDIARY_COMPANY": "Subsidiary Company",
    "HOLDING_COMPANY": "Holding Company",
    "SUPPLIER": "Supplier",
    "CREDITOR": "Creditor",
    "DEBTOR": "Debtor",
    "FRANCHISEE": "Franchisee",
    "NOT_RELATED": "Not Related"
  },
  "CounterPartyIntermediaryFIATBSIntermediaryType": {
    "FIAT_US": "FIAT US",
    "FIAT_CA": "FIAT CA"
  },
  "TransactionDetailsTransactionStatus": {
    "AUTHORIZED": "Authorized",
    "PENDING": "Pending",
    "POSTED": "Posted",
    "CANCELLED": "Cancelled"
  },
  "TransactionDetailsTransactionType": {
    "TRANSFER_IN": "Transfer In",
    "TRANSFER_OUT": "Transfer Out",
    "FEE": "Fee",
    "DEBIT_CORRECTION": "Debit Correction",
    "CREDIT_CORRECTION": "Credit Correction",
    "TRADE": "Trade",
    "INTERNAL_TRANSFER": "Internal Transfer"
  },
  "TransactionDetailsCategoryType": {
    "ADJUSTMENT": "Adjustment",
    "DEPOSIT": "Deposit",
    "EXCHANGE": "Exchange",
    "TRANSFER": "Transfer",
    "WITHDRAWAL": "Withdrawal"
  },
  "CounterPartyIntermediaryFIATUSIntermediaryType": {
    "FIAT_US": "FIAT US",
    "FIAT_CA": "FIAT CA"
  },
  "InstructionAchInstructionType": {
    "CRYPTO": "Crypto",
    "ACH": "ACH",
    "FEDWIRE": "Fedwire"
  },
  "TransferStatus": {
    "REQUESTED": "Requested",
    "ACCEPTED": "Accepted",
    "EXPIRED": "Expired",
    "CANCELLED": "Cancelled",
    "EXECUTED": "Executed",
    "REJECTED": "Rejected"
  },
  "CounterPartyLinkingConnectLinkingProvider": {
    "MX": "MX"
  },
  "CounterPartyProfileFIATJPLineOfBusiness": {
    "ARTS_AND_ANTIQUES": "Arts and Antiques",
    "AGRICULTURE": "Agriculture",
    "AUDIT_VIDEO": "Audit Video",
    "AUTOMOTIVE": "Automotive",
    "BANK_CREDIT_UNION": "Bank/Credit Union",
    "BIOTECH_PHARMACEUTICAL": "Biotech/Pharmaceutical",
    "BOOKSELLER": "Bookseller",
    "CONSTRUCTION": "Construction",
    "CASINOS_GAMBLING": "Casinos/Gambling",
    "CLOTHING": "Clothing",
    "CONSULTING_PROFESSIONAL_SERVICES": "Consulting/Professional Services",
    "CRYPTOCURRENCY": "Cryptocurrency",
    "ECIGARETTES_TOBACCO": "E-cigarettes/Tobacco",
    "ENERGY_CHEMICAL_FUEL": "Energy/Chemical/Fuel",
    "ENGINEERING": "Engineering",
    "ADULT_ENTERTAINMENT": "Adult Entertainment",
    "FINANCIAL_AND_CORPORATE_SERVICES": "Financial and Corporate Services",
    "FOOD_AND_BEVERAGE": "Food and Beverage",
    "FREIGHT_MARINE_SHIPPING_SERVICES": "Freight/Marine Shipping Services",
    "GIFTWARE_SEASONAL": "Giftware/Seasonal",
    "GOVERNMENT_PUBLIC_SERVICES": "Government/Public Services",
    "HIGH_TECH_SOFTWARE_TELECOMS": "High Tech/Software/Telecoms",
    "HOSPITALITY": "Hospitality",
    "HOUSEHOLD_GOOD_FURNITURE": "Household Goods/Furniture",
    "HUMAN_RESOURCE_SERVICES": "Human Resource Services",
    "INDUSTRIAL_EQUIPMENT": "Industrial Equipment",
    "INFORMATION_TECHNOLOGY": "Information Technology",
    "INSURANCE": "Insurance",
    "JEWELLERY_OPTICAL": "Jewellery/Optical",
    "LAW": "Law",
    "MANUFACTURING": "Manufacturing",
    "MARKETING": "Marketing",
    "MEDIA_PUBLISHING": "Media/Publishing",
    "MEDICAL_HEALTHCARE": "Medical/Healthcare",
    "MEDICAL_TOURISM": "Medical Tourism",
    "MINING": "Mining",
    "MONEY_SERVICE_BUSINESS": "Money Service Business",
    "NON_PROFIT_CHARITY": "Non-Profit/Charity",
    "ONLINE_RETAIL": "Online Retail",
    "PAYROLL": "Payroll",
    "PENSION": "Pension",
    "PERSONAL_CARE_PRODUCTS": "Personal Care Products",
    "PHOTOGRAPHY": "Photography",
    "REAL_ESTATE": "Real Estate",
    "RECREATIONAL_ACTIVITIES": "Recreational Activities",
    "RELIGIOUS_ORGANISATION": "Religious Organisation",
    "RETAIL": "Retail",
    "SECURITY": "Security",
    "SPORTING_RECREATIONAL_PRODUCTS": "Sporting/Recreational Products",
    "TRANSPORT": "Transport",
    "UNIVERSITY_EDUCATION": "University Education",
    "UTILITIES": "Utilities",
    "WASTE_MANAGEMENT": "Waste Management",
    "WINE_LIQUOR": "Wine/Liquor",
    "TECHNICAL_SUPPORT": "Technical Support",
    "OTHER": "Other"
  },
  "CounterPartyProfileFIATJPRelationshipToCustomer": {
    "SPOUSE": "Spouse",
    "EX_SPOUSE": "Ex-Spouse",
    "CHILDREN": "Children",
    "PARENT": "Parent",
    "SIBLING": "Sibling",
    "RELATIVE": "Relative",
    "SELF": "Self",
    "FRIEND": "Friend",
    "BUSINESS_PARTNER": "Business Partner",
    "CUSTOMER": "Customer",
    "EMPLOYEE": "Employee",
    "BRANCH_OFFICE": "Branch Office",
    "SUBSIDIARY_COMPANY": "Subsidiary Company",
    "HOLDING_COMPANY": "Holding Company",
    "SUPPLIER": "Supplier",
    "CREDITOR": "Creditor",
    "DEBTOR": "Debtor",
    "FRANCHISEE": "Franchisee",
    "NOT_RELATED": "Not Related"
  },
  "TransactionOriginatorFIATCAOriginatorType": {
    "FIAT_US": "FIAT US",
    "FIAT_US_LINKED": "FIAT US Linked",
    "FIAT_CA": "FIAT CA",
    "FIAT_CA_LINKED": "FIAT CA Linked",
    "CRYPTO": "Crypto"
  },
  "TransactionOriginatorFIATCARail": {
    "EFT": "EFT",
    "SWIFT": "SWIFT"
  },
  "AdjustmentDebitStatus": {
    "REQUESTED": "Requested",
    "ACCEPTED": "Accepted",
    "CANCELLED": "Cancelled",
    "EXECUTED": "Executed",
    "REJECTED": "Rejected"
  },
  "AdjustmentDebitAdjustmentType": {
    "CREDIT": "Credit",
    "DEBIT": "Debit"
  },
  "CounterPartyIntermediaryFIATINIntermediaryType": {
    "FIAT_US": "FIAT US",
    "FIAT_CA": "FIAT CA"
  },
  "DepositBaseStatus": {
    "REQUESTED": "Requested",
    "EXECUTED": "Executed",
    "FAILURE": "Failure"
  },
  "InstructionFedwireInstructionType": {
    "CRYPTO": "Crypto",
    "ACH": "ACH",
    "FEDWIRE": "Fedwire"
  },
  "CounterPartyFIATEUCounterpartyType": {
    "FIAT_US": "FIAT US",
    "FIAT_US_LINKED": "FIAT US Linked",
    "FIAT_CA": "FIAT CA",
    "FIAT_CA_LINKED": "FIAT CA Linked",
    "CRYPTO": "Crypto"
  },
  "CounterPartyFIATEUSupportedRails": {
    "SEPA_CT": "SEPA CT",
    "SWIFT": "SWIFT"
  },
  "ApplicationStateStatus": {
    "INCOMPLETE": "Incomplete",
    "READY_FOR_SUBMISSION": "Ready for Submission",
    "SUBMITTED": "Submitted",
    "PROCESSING": "Processing",
    "CHANGES_REQUESTED": "Changes Requested",
    "REJECTED": "Rejected",
    "APPROVED": "Approved"
  },
  "ApplicationStateApplicationType": {
    "INDIVIDUAL": "Individual",
    "CORPORATION": "Corporation"
  },
  "ApplicationStateApplicationErrors": {
    "MISSING_BENEFICIAL_OWNER": "Missing Beneficial Owner",
    "MISSING_OFFICER": "Missing Officer",
    "MISSING_PERSON": "Missing Person"
  },
  "CounterPartyLinkingAccountsMXLinkingProvider": {
    "MX": "MX"
  },
  "CounterPartyProfileFIATHKLineOfBusiness": {
    "ARTS_AND_ANTIQUES": "Arts and Antiques",
    "AGRICULTURE": "Agriculture",
    "AUDIT_VIDEO": "Audit Video",
    "AUTOMOTIVE": "Automotive",
    "BANK_CREDIT_UNION": "Bank/Credit Union",
    "BIOTECH_PHARMACEUTICAL": "Biotech/Pharmaceutical",
    "BOOKSELLER": "Bookseller",
    "CONSTRUCTION": "Construction",
    "CASINOS_GAMBLING": "Casinos/Gambling",
    "CLOTHING": "Clothing",
    "CONSULTING_PROFESSIONAL_SERVICES": "Consulting/Professional Services",
    "CRYPTOCURRENCY": "Cryptocurrency",
    "ECIGARETTES_TOBACCO": "E-cigarettes/Tobacco",
    "ENERGY_CHEMICAL_FUEL": "Energy/Chemical/Fuel",
    "ENGINEERING": "Engineering",
    "ADULT_ENTERTAINMENT": "Adult Entertainment",
    "FINANCIAL_AND_CORPORATE_SERVICES": "Financial and Corporate Services",
    "FOOD_AND_BEVERAGE": "Food and Beverage",
    "FREIGHT_MARINE_SHIPPING_SERVICES": "Freight/Marine Shipping Services",
    "GIFTWARE_SEASONAL": "Giftware/Seasonal",
    "GOVERNMENT_PUBLIC_SERVICES": "Government/Public Services",
    "HIGH_TECH_SOFTWARE_TELECOMS": "High Tech/Software/Telecoms",
    "HOSPITALITY": "Hospitality",
    "HOUSEHOLD_GOOD_FURNITURE": "Household Goods/Furniture",
    "HUMAN_RESOURCE_SERVICES": "Human Resource Services",
    "INDUSTRIAL_EQUIPMENT": "Industrial Equipment",
    "INFORMATION_TECHNOLOGY": "Information Technology",
    "INSURANCE": "Insurance",
    "JEWELLERY_OPTICAL": "Jewellery/Optical",
    "LAW": "Law",
    "MANUFACTURING": "Manufacturing",
    "MARKETING": "Marketing",
    "MEDIA_PUBLISHING": "Media/Publishing",
    "MEDICAL_HEALTHCARE": "Medical/Healthcare",
    "MEDICAL_TOURISM": "Medical Tourism",
    "MINING": "Mining",
    "MONEY_SERVICE_BUSINESS": "Money Service Business",
    "NON_PROFIT_CHARITY": "Non-Profit/Charity",
    "ONLINE_RETAIL": "Online Retail",
    "PAYROLL": "Payroll",
    "PENSION": "Pension",
    "PERSONAL_CARE_PRODUCTS": "Personal Care Products",
    "PHOTOGRAPHY": "Photography",
    "REAL_ESTATE": "Real Estate",
    "RECREATIONAL_ACTIVITIES": "Recreational Activities",
    "RELIGIOUS_ORGANISATION": "Religious Organisation",
    "RETAIL": "Retail",
    "SECURITY": "Security",
    "SPORTING_RECREATIONAL_PRODUCTS": "Sporting/Recreational Products",
    "TRANSPORT": "Transport",
    "UNIVERSITY_EDUCATION": "University Education",
    "UTILITIES": "Utilities",
    "WASTE_MANAGEMENT": "Waste Management",
    "WINE_LIQUOR": "Wine/Liquor",
    "TECHNICAL_SUPPORT": "Technical Support",
    "OTHER": "Other"
  },
  "CounterPartyProfileFIATHKRelationshipToCustomer": {
    "SPOUSE": "Spouse",
    "EX_SPOUSE": "Ex-Spouse",
    "CHILDREN": "Children",
    "PARENT": "Parent",
    "SIBLING": "Sibling",
    "RELATIVE": "Relative",
    "SELF": "Self",
    "FRIEND": "Friend",
    "BUSINESS_PARTNER": "Business Partner",
    "CUSTOMER": "Customer",
    "EMPLOYEE": "Employee",
    "BRANCH_OFFICE": "Branch Office",
    "SUBSIDIARY_COMPANY": "Subsidiary Company",
    "HOLDING_COMPANY": "Holding Company",
    "SUPPLIER": "Supplier",
    "CREDITOR": "Creditor",
    "DEBTOR": "Debtor",
    "FRANCHISEE": "Franchisee",
    "NOT_RELATED": "Not Related"
  },
  "DepositPushStatus": {
    "REQUESTED": "Requested",
    "EXECUTED": "Executed",
    "FAILURE": "Failure"
  },
  "DepositPushDepositType": {
    "PUSH": "Push",
    "PULL": "Pull"
  },
  "TransactionOriginatorAccountCRYPTOWalletType": {
    "INSTITUTION": "Institution",
    "OTHER": "Other",
    "UNKNOWN": "Unknown"
  },
  "CounterPartyLinkingConnectMXLinkingProvider": {
    "MX": "MX"
  },
  "CounterPartyFIATINCounterpartyType": {
    "FIAT_US": "Fiat US",
    "FIAT_US_LINKED": "Fiat US Linked",
    "FIAT_CA": "Fiat CA",
    "FIAT_CA_LINKED": "Fiat CA Linked",
    "CRYPTO": "Crypto"
  },
  "CounterPartyFIATINSupportedRails": {
    "IMPS": "IMPS",
    "NFT": "NFT",
    "UP": "UP",
    "SWIFT": "SWIFT"
  },
  "ExchangeStatus": {
    "REQUESTED": "Requested",
    "ACCEPTED": "Accepted",
    "EXPIRED": "Expired",
    "CANCELLED": "Cancelled",
    "EXECUTED": "Executed",
    "REJECTED": "Rejected"
  },
  "ExchangeExchangeType": {
    "QUOTE": "Quote",
    "MARKET": "Market"
  },
  "ExchangeAction": {
    "FIX_DESTINATION": "Fix Destination",
    "FIX_SOURCE": "Fix Source"
  },
  "CounterPartyIntermediaryFIATEUIntermediaryType": {
    "FIAT_US": "Fiat US",
    "FIAT_CA": "Fiat CA"
  },
  "CounterPartyProfileFIATINLineOfBusiness": {
    "ARTS_AND_ANTIQUES": "Arts and Antiques",
    "AGRICULTURE": "Agriculture",
    "AUDIT_VIDEO": "Audit Video",
    "AUTOMOTIVE": "Automotive",
    "BANK_CREDIT_UNION": "Bank/Credit Union",
    "BIOTECH_PHARMACEUTICAL": "Biotech/Pharmaceutical",
    "BOOKSELLER": "Bookseller",
    "CONSTRUCTION": "Construction",
    "CASINOS_GAMBLING": "Casinos/Gambling",
    "CLOTHING": "Clothing",
    "CONSULTING_PROFESSIONAL_SERVICES": "Consulting/Professional Services",
    "CRYPTOCURRENCY": "Cryptocurrency",
    "ECIGARETTES_TOBACCO": "E-cigarettes/Tobacco",
    "ENERGY_CHEMICAL_FUEL": "Energy/Chemical/Fuel",
    "ENGINEERING": "Engineering",
    "ADULT_ENTERTAINMENT": "Adult Entertainment",
    "FINANCIAL_AND_CORPORATE_SERVICES": "Financial and Corporate Services",
    "FOOD_AND_BEVERAGE": "Food and Beverage",
    "FREIGHT_MARINE_SHIPPING_SERVICES": "Freight/Marine/Shipping Services",
    "GIFTWARE_SEASONAL": "Giftware/Seasonal",
    "GOVERNMENT_PUBLIC_SERVICES": "Government/Public Services",
    "HIGH_TECH_SOFTWARE_TELECOMS": "High Tech/Software/Telecoms",
    "HOSPITALITY": "Hospitality",
    "HOUSEHOLD_GOOD_FURNITURE": "Household Goods/Furniture",
    "HUMAN_RESOURCE_SERVICES": "Human Resource Services",
    "INDUSTRIAL_EQUIPMENT": "Industrial Equipment",
    "INFORMATION_TECHNOLOGY": "Information Technology",
    "INSURANCE": "Insurance",
    "JEWELLERY_OPTICAL": "Jewellery/Optical",
    "LAW": "Law",
    "MANUFACTURING": "Manufacturing",
    "MARKETING": "Marketing",
    "MEDIA_PUBLISHING": "Media/Publishing",
    "MEDICAL_HEALTHCARE": "Medical/Healthcare",
    "MEDICAL_TOURISM": "Medical Tourism",
    "MINING": "Mining",
    "MONEY_SERVICE_BUSINESS": "Money Service Business",
    "NON_PROFIT_CHARITY": "Non-Profit/Charity",
    "ONLINE_RETAIL": "Online Retail",
    "PAYROLL": "Payroll",
    "PENSION": "Pension",
    "PERSONAL_CARE_PRODUCTS": "Personal Care Products",
    "PHOTOGRAPHY": "Photography",
    "REAL_ESTATE": "Real Estate",
    "RECREATIONAL_ACTIVITIES": "Recreational Activities",
    "RELIGIOUS_ORGANISATION": "Religious Organisation",
    "RETAIL": "Retail",
    "SECURITY": "Security",
    "SPORTING_RECREATIONAL_PRODUCTS": "Sporting/Recreational Products",
    "TRANSPORT": "Transport",
    "UNIVERSITY_EDUCATION": "University/Education",
    "UTILITIES": "Utilities",
    "WASTE_MANAGEMENT": "Waste Management",
    "WINE_LIQUOR": "Wine/Liquor",
    "TECHNICAL_SUPPORT": "Technical Support",
    "OTHER": "Other"
  },
  "CounterPartyProfileFIATINRelationshipToCustomer": {
    "SPOUSE": "Spouse",
    "EX_SPOUSE": "Ex-Spouse",
    "CHILDREN": "Children",
    "PARENT": "Parent",
    "SIBLING": "Sibling",
    "RELATIVE": "Relative",
    "SELF": "Self",
    "FRIEND": "Friend",
    "BUSINESS_PARTNER": "Business Partner",
    "CUSTOMER": "Customer",
    "EMPLOYEE": "Employee",
    "BRANCH_OFFICE": "Branch Office",
    "SUBSIDIARY_COMPANY": "Subsidiary Company",
    "HOLDING_COMPANY": "Holding Company",
    "SUPPLIER": "Supplier",
    "CREDITOR": "Creditor",
    "DEBTOR": "Debtor",
    "FRANCHISEE": "Franchisee",
    "NOT_RELATED": "Not Related"
  },
  "CounterPartyAccountFIATUSType": {
    "CHECKING": "Checking",
    "SAVING": "Saving"
  },
  "CounterPartyAccountFIATBSType": {
    "CHECKING": "Checking",
    "SAVING": "Saving"
  },
  "SettlementSettlementStatus": {
    "INITIALIZED": "Initialized",
    "DELIVERING": "Delivering",
    "CONVERTING": "Converting",
    "SETTLED": "Settled"
  },
  "SettlementSettlementAssetType": {
    "FIAT": "Fiat",
    "BITCOIN": "Bitcoin",
    "ETHEREUM": "Ethereum",
    "POLYGON": "Polygon"
  },
  "TransactionOriginatorCRYPTOOriginatorType": {
    "FIAT_US": "Fiat US",
    "FIAT_US_LINKED": "Fiat US Linked",
    "FIAT_CA": "Fiat CA",
    "FIAT_CA_LINKED": "Fiat CA Linked",
    "CRYPTO": "Crypto"
  },
  "TransactionOriginatorCRYPTORail": {
    "CRYPTO": "Crypto"
  },
  "CounterPartyIntermediaryFIATHKIntermediaryType": {
    "FIAT_US": "Fiat US",
    "FIAT_CA": "Fiat CA"
  },
  "SettlementDetailsSourceAssetType": {
    "FIAT": "Fiat",
    "BITCOIN": "Bitcoin",
    "ETHEREUM": "Ethereum",
    "POLYGON": "Polygon"
  },
  "SettlementDetailsDestinationAssetType": {
    "FIAT": "Fiat",
    "BITCOIN": "Bitcoin",
    "ETHEREUM": "Ethereum",
    "POLYGON": "Polygon"
  },
  "WithdrawalBaseStatus": {
    "REQUESTED": "Requested",
    "REJECTED": "Rejected",
    "EXPIRED": "Expired",
    "ACCEPTED": "Accepted",
    "EXECUTED": "Executed",
    "CANCELLED": "Cancelled"
  },
  "TransactionTransactionStatus": {
    "AUTHORIZED": "Authorized",
    "PENDING": "Pending",
    "POSTED": "Posted",
    "CANCELLED": "Cancelled"
  },
  "TransactionTransactionType": {
    "TRANSFER_IN": "Transfer In",
    "TRANSFER_OUT": "Transfer Out",
    "FEE": "Fee",
    "DEBIT_CORRECTION": "Debit Correction",
    "CREDIT_CORRECTION": "Credit Correction",
    "TRADE": "Trade",
    "INTERNAL_TRANSFER": "Internal Transfer"
  },
  "TransactionCategoryType": {
    "ADJUSTMENT": "Adjustment",
    "DEPOSIT": "Deposit",
    "EXCHANGE": "Exchange",
    "TRANSFER": "Transfer",
    "WITHDRAWAL": "Withdrawal"
  },
  "CounterPartyFIATHKCounterpartyType": {
    "FIAT_US": "Fiat US",
    "FIAT_US_LINKED": "Fiat US Linked",
    "FIAT_CA": "Fiat CA",
    "FIAT_CA_LINKED": "Fiat CA Linked",
    "CRYPTO": "Crypto"
  },
  "CounterPartyFIATHKSupportedRails": {
    "SWIFT": "SWIFT"
  },
  "AdjustmentCreditStatus": {
    "REQUESTED": "Requested",
    "ACCEPTED": "Accepted",
    "CANCELLED": "Cancelled",
    "EXECUTED": "Executed",
    "REJECTED": "Rejected"
  },
  "AdjustmentCreditAdjustmentType": {
    "CREDIT": "Credit",
    "DEBIT": "Debit"
  },
  "CounterPartyFIATUSLINKEDCounterpartyType": {
    "FIAT_US": "Fiat US",
    "FIAT_US_LINKED": "Fiat US Linked",
    "FIAT_CA": "Fiat CA",
    "FIAT_CA_LINKED": "Fiat CA Linked",
    "CRYPTO": "Crypto"
  },
  "CounterPartyFIATUSLINKEDSupportedRails": {
    "ACH": "ACH"
  },
  "CounterPartyProfileFIATEULineOfBusiness": {
    "ARTS_AND_ANTIQUES": "Arts and Antiques",
    "AGRICULTURE": "Agriculture",
    "AUDIT_VIDEO": "Audit Video",
    "AUTOMOTIVE": "Automotive",
    "BANK_CREDIT_UNION": "Bank/Credit Union",
    "BIOTECH_PHARMACEUTICAL": "Biotech/Pharmaceutical",
    "BOOKSELLER": "Bookseller",
    "CONSTRUCTION": "Construction",
    "CASINOS_GAMBLING": "Casinos/Gambling",
    "CLOTHING": "Clothing",
    "CONSULTING_PROFESSIONAL_SERVICES": "Consulting/Professional Services",
    "CRYPTOCURRENCY": "Cryptocurrency",
    "ECIGARETTES_TOBACCO": "E-cigarettes/Tobacco",
    "ENERGY_CHEMICAL_FUEL": "Energy/Chemical/Fuel",
    "ENGINEERING": "Engineering",
    "ADULT_ENTERTAINMENT": "Adult Entertainment",
    "FINANCIAL_AND_CORPORATE_SERVICES": "Financial and Corporate Services",
    "FOOD_AND_BEVERAGE": "Food and Beverage",
    "FREIGHT_MARINE_SHIPPING_SERVICES": "Freight/Marine/Shipping Services",
    "GIFTWARE_SEASONAL": "Giftware/Seasonal",
    "GOVERNMENT_PUBLIC_SERVICES": "Government/Public Services",
    "HIGH_TECH_SOFTWARE_TELECOMS": "High Tech/Software/Telecoms",
    "HOSPITALITY": "Hospitality",
    "HOUSEHOLD_GOOD_FURNITURE": "Household Goods/Furniture",
    "HUMAN_RESOURCE_SERVICES": "Human Resource Services",
    "INDUSTRIAL_EQUIPMENT": "Industrial Equipment",
    "INFORMATION_TECHNOLOGY": "Information Technology",
    "INSURANCE": "Insurance",
    "JEWELLERY_OPTICAL": "Jewellery/Optical",
    "LAW": "Law",
    "MANUFACTURING": "Manufacturing",
    "MARKETING": "Marketing",
    "MEDIA_PUBLISHING": "Media/Publishing",
    "MEDICAL_HEALTHCARE": "Medical/Healthcare",
    "MEDICAL_TOURISM": "Medical Tourism",
    "MINING": "Mining",
    "MONEY_SERVICE_BUSINESS": "Money Service Business",
    "NON_PROFIT_CHARITY": "Non-Profit/Charity",
    "ONLINE_RETAIL": "Online Retail",
    "PAYROLL": "Payroll",
    "PENSION": "Pension",
    "PERSONAL_CARE_PRODUCTS": "Personal Care Products",
    "PHOTOGRAPHY": "Photography",
    "REAL_ESTATE": "Real Estate",
    "RECREATIONAL_ACTIVITIES": "Recreational Activities",
    "RELIGIOUS_ORGANISATION": "Religious Organisation",
    "RETAIL": "Retail",
    "SECURITY": "Security",
    "SPORTING_RECREATIONAL_PRODUCTS": "Sporting/Recreational Products",
    "TRANSPORT": "Transport",
    "UNIVERSITY_EDUCATION": "University/Education",
    "UTILITIES": "Utilities",
    "WASTE_MANAGEMENT": "Waste Management",
    "WINE_LIQUOR": "Wine/Liquor",
    "TECHNICAL_SUPPORT": "Technical Support",
    "OTHER": "Other"
  },
  "CounterPartyProfileFIATEURelationshipToCustomer": {
    "SPOUSE": "Spouse",
    "EX_SPOUSE": "Ex-Spouse",
    "CHILDREN": "Children",
    "PARENT": "Parent",
    "SIBLING": "Sibling",
    "RELATIVE": "Relative",
    "SELF": "Self",
    "FRIEND": "Friend",
    "BUSINESS_PARTNER": "Business Partner",
    "CUSTOMER": "Customer",
    "EMPLOYEE": "Employee",
    "BRANCH_OFFICE": "Branch Office",
    "SUBSIDIARY_COMPANY": "Subsidiary Company",
    "HOLDING_COMPANY": "Holding Company",
    "SUPPLIER": "Supplier",
    "CREDITOR": "Creditor",
    "DEBTOR": "Debtor",
    "FRANCHISEE": "Franchisee",
    "NOT_RELATED": "Not Related"
  },
  "CounterPartyCounterpartyType": {
    "FIAT_US": "Fiat US",
    "FIAT_US_LINKED": "Fiat US Linked",
    "FIAT_CA": "Fiat CA",
    "FIAT_CA_LINKED": "Fiat CA Linked",
    "CRYPTO": "Crypto"
  },
  "CounterPartyFIATSGCounterpartyType": {
    "FIAT_US": "Fiat US",
    "FIAT_US_LINKED": "Fiat US Linked",
    "FIAT_CA": "Fiat CA",
    "FIAT_CA_LINKED": "Fiat CA Linked",
    "CRYPTO": "Crypto"
  },
  "CounterPartyFIATSGSupportedRails": {
    "SWIFT": "SWIFT"
  },
  "CounterPartyProfileFIATGBLineOfBusiness": {
    "ARTS_AND_ANTIQUES": "Arts and Antiques",
    "AGRICULTURE": "Agriculture",
    "AUDIT_VIDEO": "Audit Video",
    "AUTOMOTIVE": "Automotive",
    "BANK_CREDIT_UNION": "Bank/Credit Union",
    "BIOTECH_PHARMACEUTICAL": "Biotech/Pharmaceutical",
    "BOOKSELLER": "Bookseller",
    "CONSTRUCTION": "Construction",
    "CASINOS_GAMBLING": "Casinos/Gambling",
    "CLOTHING": "Clothing",
    "CONSULTING_PROFESSIONAL_SERVICES": "Consulting/Professional Services",
    "CRYPTOCURRENCY": "Cryptocurrency",
    "ECIGARETTES_TOBACCO": "E-cigarettes/Tobacco",
    "ENERGY_CHEMICAL_FUEL": "Energy/Chemical/Fuel",
    "ENGINEERING": "Engineering",
    "ADULT_ENTERTAINMENT": "Adult Entertainment",
    "FINANCIAL_AND_CORPORATE_SERVICES": "Financial and Corporate Services",
    "FOOD_AND_BEVERAGE": "Food and Beverage",
    "FREIGHT_MARINE_SHIPPING_SERVICES": "Freight/Marine/Shipping Services",
    "GIFTWARE_SEASONAL": "Giftware/Seasonal",
    "GOVERNMENT_PUBLIC_SERVICES": "Government/Public Services",
    "HIGH_TECH_SOFTWARE_TELECOMS": "High Tech/Software/Telecoms",
    "HOSPITALITY": "Hospitality",
    "HOUSEHOLD_GOOD_FURNITURE": "Household Goods/Furniture",
    "HUMAN_RESOURCE_SERVICES": "Human Resource Services",
    "INDUSTRIAL_EQUIPMENT": "Industrial Equipment",
    "INFORMATION_TECHNOLOGY": "Information Technology",
    "INSURANCE": "Insurance",
    "JEWELLERY_OPTICAL": "Jewellery/Optical",
    "LAW": "Law",
    "MANUFACTURING": "Manufacturing",
    "MARKETING": "Marketing",
    "MEDIA_PUBLISHING": "Media/Publishing",
    "MEDICAL_HEALTHCARE": "Medical/Healthcare",
    "MEDICAL_TOURISM": "Medical Tourism",
    "MINING": "Mining",
    "MONEY_SERVICE_BUSINESS": "Money Service Business",
    "NON_PROFIT_CHARITY": "Non-Profit/Charity",
    "ONLINE_RETAIL": "Online Retail",
    "PAYROLL": "Payroll",
    "PENSION": "Pension",
    "PERSONAL_CARE_PRODUCTS": "Personal Care Products",
    "PHOTOGRAPHY": "Photography",
    "REAL_ESTATE": "Real Estate",
    "RECREATIONAL_ACTIVITIES": "Recreational Activities",
    "RELIGIOUS_ORGANISATION": "Religious Organisation",
    "RETAIL": "Retail",
    "SECURITY": "Security",
    "SPORTING_RECREATIONAL_PRODUCTS": "Sporting/Recreational Products",
    "TRANSPORT": "Transport",
    "UNIVERSITY_EDUCATION": "University/Education",
    "UTILITIES": "Utilities",
    "WASTE_MANAGEMENT": "Waste Management",
    "WINE_LIQUOR": "Wine/Liquor",
    "TECHNICAL_SUPPORT": "Technical Support",
    "OTHER": "Other"
  },
  "CounterPartyProfileFIATGBRelationshipToCustomer": {
    "SPOUSE": "Spouse",
    "EX_SPOUSE": "Ex-Spouse",
    "CHILDREN": "Children",
    "PARENT": "Parent",
    "SIBLING": "Sibling",
    "RELATIVE": "Relative",
    "SELF": "Self",
    "FRIEND": "Friend",
    "BUSINESS_PARTNER": "Business Partner",
    "CUSTOMER": "Customer",
    "EMPLOYEE": "Employee",
    "BRANCH_OFFICE": "Branch Office",
    "SUBSIDIARY_COMPANY": "Subsidiary Company",
    "HOLDING_COMPANY": "Holding Company",
    "SUPPLIER": "Supplier",
    "CREDITOR": "Creditor",
    "DEBTOR": "Debtor",
    "FRANCHISEE": "Franchisee",
    "NOT_RELATED": "Not Related"
  },
  "SubscriptionEventType": {
    "APPLICATION_READY_FOR_SUBMISSION": "Application Ready for Submission",
    "APPLICATION_SUBMITTED": "Application Submitted",
    "APPLICATION_PROCESSING": "Application Processing",
    "APPLICATION_CHANGE_REQUESTED": "Application Change Requested",
    "APPLICATION_REJECTED": "Application Rejected",
    "APPLICATION_APPROVED": "Application Approved",
    "CUSTOMER_ACTIVE": "Customer Active",
    "CUSTOMER_CLOSED": "Customer Closed",
    "CUSTOMER_PENDING": "Customer Pending",
    "CUSTOMER_EDD": "Customer EDD",
    "CUSTOMER_FROZEN": "Customer Frozen",
    "ACCOUNT_OPEN": "Account Open",
    "ACCOUNT_CLOSED": "Account Closed",
    "ACCOUNT_FROZEN": "Account Frozen",
    "ACCOUNT_PENDING": "Account Pending",
    "ACCOUNT_EDD": "Account EDD",
    "ACCOUNT_DORMANT": "Account Dormant",
    "TRANSACTION_AUTHORIZED": "Transaction Authorized",
    "TRANSACTION_PENDING": "Transaction Pending",
    "TRANSACTION_POSTED": "Transaction Posted",
    "TRANSACTION_CANCELLED": "Transaction Cancelled"
  },
  "DepositStatus": {
    "REQUESTED": "Requested",
    "EXECUTED": "Executed",
    "FAILURE": "Failure"
  },
  "DepositDepositType": {
    "PUSH": "Push",
    "PULL": "Pull"
  },
  "CounterPartyProfileCRYPTOLineOfBusiness": {
    "ARTS_AND_ANTIQUES": "Arts and Antiques",
    "AGRICULTURE": "Agriculture",
    "AUDIT_VIDEO": "Audit Video",
    "AUTOMOTIVE": "Automotive",
    "BANK_CREDIT_UNION": "Bank/Credit Union",
    "BIOTECH_PHARMACEUTICAL": "Biotech/Pharmaceutical",
    "BOOKSELLER": "Bookseller",
    "CONSTRUCTION": "Construction",
    "CASINOS_GAMBLING": "Casinos/Gambling",
    "CLOTHING": "Clothing",
    "CONSULTING_PROFESSIONAL_SERVICES": "Consulting/Professional Services",
    "CRYPTOCURRENCY": "Cryptocurrency",
    "ECIGARETTES_TOBACCO": "E-cigarettes/Tobacco",
    "ENERGY_CHEMICAL_FUEL": "Energy/Chemical/Fuel",
    "ENGINEERING": "Engineering",
    "ADULT_ENTERTAINMENT": "Adult Entertainment",
    "FINANCIAL_AND_CORPORATE_SERVICES": "Financial and Corporate Services",
    "FOOD_AND_BEVERAGE": "Food and Beverage",
    "FREIGHT_MARINE_SHIPPING_SERVICES": "Freight/Marine/Shipping Services",
    "GIFTWARE_SEASONAL": "Giftware/Seasonal",
    "GOVERNMENT_PUBLIC_SERVICES": "Government/Public Services",
    "HIGH_TECH_SOFTWARE_TELECOMS": "High Tech/Software/Telecoms",
    "HOSPITALITY": "Hospitality",
    "HOUSEHOLD_GOOD_FURNITURE": "Household Goods/Furniture",
    "HUMAN_RESOURCE_SERVICES": "Human Resource Services",
    "INDUSTRIAL_EQUIPMENT": "Industrial Equipment",
    "INFORMATION_TECHNOLOGY": "Information Technology",
    "INSURANCE": "Insurance",
    "JEWELLERY_OPTICAL": "Jewellery/Optical",
    "LAW": "Law",
    "MANUFACTURING": "Manufacturing",
    "MARKETING": "Marketing",
    "MEDIA_PUBLISHING": "Media/Publishing",
    "MEDICAL_HEALTHCARE": "Medical/Healthcare",
    "MEDICAL_TOURISM": "Medical Tourism",
    "MINING": "Mining",
    "MONEY_SERVICE_BUSINESS": "Money Service Business",
    "NON_PROFIT_CHARITY": "Non-Profit/Charity",
    "ONLINE_RETAIL": "Online Retail",
    "PAYROLL": "Payroll",
    "PENSION": "Pension",
    "PERSONAL_CARE_PRODUCTS": "Personal Care Products",
    "PHOTOGRAPHY": "Photography",
    "REAL_ESTATE": "Real Estate",
    "RECREATIONAL_ACTIVITIES": "Recreational Activities",
    "RELIGIOUS_ORGANISATION": "Religious Organisation",
    "RETAIL": "Retail",
    "SECURITY": "Security",
    "SPORTING_RECREATIONAL_PRODUCTS": "Sporting/Recreational Products",
    "TRANSPORT": "Transport",
    "UNIVERSITY_EDUCATION": "University/Education",
    "UTILITIES": "Utilities",
    "WASTE_MANAGEMENT": "Waste Management",
    "WINE_LIQUOR": "Wine/Liquor",
    "TECHNICAL_SUPPORT": "Technical Support",
    "OTHER": "Other"
  },
  "CounterPartyProfileCRYPTORelationshipToCustomer": {
    "SPOUSE": "Spouse",
    "EX_SPOUSE": "Ex-Spouse",
    "CHILDREN": "Children",
    "PARENT": "Parent",
    "SIBLING": "Sibling",
    "RELATIVE": "Relative",
    "SELF": "Self",
    "FRIEND": "Friend",
    "BUSINESS_PARTNER": "Business Partner",
    "CUSTOMER": "Customer",
    "EMPLOYEE": "Employee",
    "BRANCH_OFFICE": "Branch Office",
    "SUBSIDIARY_COMPANY": "Subsidiary Company",
    "HOLDING_COMPANY": "Holding Company",
    "SUPPLIER": "Supplier",
    "CREDITOR": "Creditor",
    "DEBTOR": "Debtor",
    "FRANCHISEE": "Franchisee",
    "NOT_RELATED": "Not Related"
  },
  "CounterPartyFIATMYCounterpartyType": {
    "FIAT_US": "Fiat US",
    "FIAT_US_LINKED": "Fiat US Linked",
    "FIAT_CA": "Fiat CA",
    "FIAT_CA_LINKED": "Fiat CA Linked",
    "CRYPTO": "Crypto"
  },
  "CounterPartyFIATMYSupportedRails": {
    "SWIFT": "SWIFT"
  },
  "CounterPartyIntermediaryIntermediaryType": {
    "FIAT_US": "United States",
    "FIAT_CA": "Canada",
    "FIAT_EU": "Europe",
    "FIAT_GB": "Great Bretain",
    "FIAT_PA": "Panama",
    "FIAT_MY": "Malaysia",
    "FIAT_SG": "Singapore",
    "FIAT_JP": "Japan",
    "FIAT_HK": "Hong Kong",
    "FIAT_CN": "China",
    "FIAT_BS": "Bahamas",
    "FIAT_IN": "India"
  },
  "CounterPartyLinkingDetailsLinkingProvider": {
    "MX": "MX"
  },
  "CounterPartyBASICCounterpartyType": {
    "FIAT_US": "Fiat US",
    "FIAT_US_LINKED": "Fiat US Linked",
    "FIAT_CA": "Fiat CA",
    "FIAT_CA_LINKED": "Fiat CA Linked",
    "CRYPTO": "Crypto"
  },
  "CounterPartyIntermediaryFIATMYIntermediaryType": {
    "FIAT_US": "Fiat US",
    "FIAT_CA": "Fiat CA"
  },
  "CounterPartyIntermediaryFIATSGIntermediaryType": {
    "FIAT_US": "Fiat US",
    "FIAT_CA": "Fiat CA"
  },
  "ApplicationIndividualStatus": {
    "INCOMPLETE": "Incomplete",
    "READY_FOR_SUBMISSION": "Ready for Submission",
    "SUBMITTED": "Submitted",
    "PROCESSING": "Processing",
    "CHANGES_REQUESTED": "Changes Requested",
    "REJECTED": "Rejected",
    "APPROVED": "Approved"
  },
  "ApplicationIndividualApplicationType": {
    "INDIVIDUAL": "Individual",
    "CORPORATION": "Corporation"
  },
  "IndividualApplicationUsResidencyStatus": {
    "US_CITIZEN": "US Citizen",
    "RESIDENT_ALIEN": "Resident Alien",
    "NON_RESIDENT_ALIEN": "Non-Resident Alien"
  },
  "CorporationCustomerCorporateEntityType": {
    "C_CORP_PRIVATE": "C Corp (Private)",
    "C_CORP_PUBLIC": "C Corp (Public)",
    "LLC": "LLC",
    "LLP": "LLP",
    "LP": "LP",
    "S_CORP": "S Corp",
    "OTHER": "Other"
  },
  "WithdrawalStatus": {
    "REQUESTED": "Requested",
    "REJECTED": "Rejected",
    "EXPIRED": "Expired",
    "ACCEPTED": "Accepted",
    "EXECUTED": "Executed",
    "CANCELLED": "Cancelled"
  },
  "WithdrawalWithdrawalRail": {
    "ACH": "ACH",
    "FEDWIRE": "Fedwire",
    "SWIFT": "SWIFT",
    "CRYPTO": "Crypto",
    "EFT": "EFT"
  },
  "WithdrawalPurpose": {
    "PERSONAL_ACCOUNT": "Personal Account",
    "FAMILY": "Family",
    "INSURANCE": "Insurance",
    "INVESTMENT": "Investment",
    "REAL_ESTATE": "Real Estate",
    "TUITION": "Tuition",
    "MEDICAL": "Medical",
    "TRAVEL": "Travel",
    "TRADE_TRANSACTIONS": "Trade Transactions",
    "UTILITY": "Utility",
    "TAX": "Tax",
    "LOAN": "Loan",
    "BILLS": "Bills",
    "PAYROLL": "Payroll",
    "TELECOM": "Telecom",
    "INTELLECTUAL_PROPERTY": "Intellectual Property",
    "OTHER_BUSINESS_SERVICES": "Other Business Services",
    "CHARITABLE_DONATIONS": "Charitable Donations",
    "MORTGAGE": "Mortgage",
    "EXPENSES_REIMBURSEMENT": "Expenses Reimbursement",
    "PROFESSIONAL_SERVICES": "Professional Services",
    "MARKETING": "Marketing",
    "RENTAL_PROPERTY": "Rental Property",
    "OTHER": "Other"
  },
  "CounterPartyIntermediaryFIATGBIntermediaryType": {
    "FIAT_US": "Fiat US",
    "FIAT_CA": "Fiat CA"
  },
  "TransactionOriginatorOriginatorType": {
    "FIAT_US": "Fiat US",
    "FIAT_US_LINKED": "Fiat US Linked",
    "FIAT_CA": "Fiat CA",
    "FIAT_CA_LINKED": "Fiat CA Linked",
    "CRYPTO": "Crypto"
  },
  "CounterPartyFIATGBCounterpartyType": {
    "FIAT_US": "Fiat US",
    "FIAT_US_LINKED": "Fiat US Linked",
    "FIAT_CA": "Fiat CA",
    "FIAT_CA_LINKED": "Fiat CA Linked",
    "CRYPTO": "Crypto"
  },
  "CounterPartyFIATGBSupportedRails": {
    "FPS": "FPS",
    "SWIFT": "SWIFT"
  },
  "RequestCustomerCustomerType": {
    "INDIVIDUAL": "Individual",
    "CORPORATION": "Corporation"
  },
  "RequestCustomerStatus": {
    "ACTIVE": "Active",
    "CLOSED": "Closed",
    "FROZEN": "Frozen",
    "PENDING": "Pending",
    "EDD": "EDD",
    "DORMANT": "Dormant"
  },
  "CounterPartyProfileFIATMYLineOfBusiness": {
    "ARTS_AND_ANTIQUES": "Arts and Antiques",
    "AGRICULTURE": "Agriculture",
    "AUDIT_VIDEO": "Audit Video",
    "AUTOMOTIVE": "Automotive",
    "BANK_CREDIT_UNION": "Bank/Credit Union",
    "BIOTECH_PHARMACEUTICAL": "Biotech/Pharmaceutical",
    "BOOKSELLER": "Bookseller",
    "CONSTRUCTION": "Construction",
    "CASINOS_GAMBLING": "Casinos/Gambling",
    "CLOTHING": "Clothing",
    "CONSULTING_PROFESSIONAL_SERVICES": "Consulting/Professional Services",
    "CRYPTOCURRENCY": "Cryptocurrency",
    "ECIGARETTES_TOBACCO": "E-cigarettes/Tobacco",
    "ENERGY_CHEMICAL_FUEL": "Energy/Chemical/Fuel",
    "ENGINEERING": "Engineering",
    "ADULT_ENTERTAINMENT": "Adult Entertainment",
    "FINANCIAL_AND_CORPORATE_SERVICES": "Financial and Corporate Services",
    "FOOD_AND_BEVERAGE": "Food and Beverage",
    "FREIGHT_MARINE_SHIPPING_SERVICES": "Freight/Marine/Shipping Services",
    "GIFTWARE_SEASONAL": "Giftware/Seasonal",
    "GOVERNMENT_PUBLIC_SERVICES": "Government/Public Services",
    "HIGH_TECH_SOFTWARE_TELECOMS": "High Tech/Software/Telecoms",
    "HOSPITALITY": "Hospitality",
    "HOUSEHOLD_GOOD_FURNITURE": "Household Goods/Furniture",
    "HUMAN_RESOURCE_SERVICES": "Human Resource Services",
    "INDUSTRIAL_EQUIPMENT": "Industrial Equipment",
    "INFORMATION_TECHNOLOGY": "Information Technology",
    "INSURANCE": "Insurance",
    "JEWELLERY_OPTICAL": "Jewellery/Optical",
    "LAW": "Law",
    "MANUFACTURING": "Manufacturing",
    "MARKETING": "Marketing",
    "MEDIA_PUBLISHING": "Media/Publishing",
    "MEDICAL_HEALTHCARE": "Medical/Healthcare",
    "MEDICAL_TOURISM": "Medical Tourism",
    "MINING": "Mining",
    "MONEY_SERVICE_BUSINESS": "Money Service Business",
    "NON_PROFIT_CHARITY": "Non-Profit/Charity",
    "ONLINE_RETAIL": "Online Retail",
    "PAYROLL": "Payroll",
    "PENSION": "Pension",
    "PERSONAL_CARE_PRODUCTS": "Personal Care Products",
    "PHOTOGRAPHY": "Photography",
    "REAL_ESTATE": "Real Estate",
    "RECREATIONAL_ACTIVITIES": "Recreational Activities",
    "RELIGIOUS_ORGANISATION": "Religious Organisation",
    "RETAIL": "Retail",
    "SECURITY": "Security",
    "SPORTING_RECREATIONAL_PRODUCTS": "Sporting/Recreational Products",
    "TRANSPORT": "Transport",
    "UNIVERSITY_EDUCATION": "University/Education",
    "UTILITIES": "Utilities",
    "WASTE_MANAGEMENT": "Waste Management",
    "WINE_LIQUOR": "Wine/Liquor",
    "TECHNICAL_SUPPORT": "Technical Support",
    "OTHER": "Other"
  },
  "CounterPartyProfileFIATMYRelationshipToCustomer": {
    "SPOUSE": "Spouse",
    "EX_SPOUSE": "Ex-Spouse",
    "CHILDREN": "Children",
    "PARENT": "Parent",
    "SIBLING": "Sibling",
    "RELATIVE": "Relative",
    "SELF": "Self",
    "FRIEND": "Friend",
    "BUSINESS_PARTNER": "Business Partner",
    "CUSTOMER": "Customer",
    "EMPLOYEE": "Employee",
    "BRANCH_OFFICE": "Branch Office",
    "SUBSIDIARY_COMPANY": "Subsidiary Company",
    "HOLDING_COMPANY": "Holding Company",
    "SUPPLIER": "Supplier",
    "CREDITOR": "Creditor",
    "DEBTOR": "Debtor",
    "FRANCHISEE": "Franchisee",
    "NOT_RELATED": "Not Related"
  },
  "CounterPartyCRYPTOCounterpartyType": {
    "FIAT_US": "Fiat US",
    "FIAT_US_LINKED": "Fiat US Linked",
    "FIAT_CA": "Fiat CA",
    "FIAT_CA_LINKED": "Fiat CA Linked",
    "CRYPTO": "Crypto"
  },
  "CounterPartyCRYPTOSupportedRails": {
    "CRYPTO": "Crypto"
  },
  "CounterPartyLinkingAccountsLinkingProvider": {
    "MX": "MX"
  },
  "TransferBaseStatus": {
    "REQUESTED": "Requested",
    "ACCEPTED": "Accepted",
    "EXPIRED": "Expired",
    "CANCELLED": "Cancelled",
    "EXECUTED": "Executed",
    "REJECTED": "Rejected"
  },
  "CounterPartyProfileFIATSGLineOfBusiness": {
    "ARTS_AND_ANTIQUES": "Arts and Antiques",
    "AGRICULTURE": "Agriculture",
    "AUDIT_VIDEO": "Audit Video",
    "AUTOMOTIVE": "Automotive",
    "BANK_CREDIT_UNION": "Bank/Credit Union",
    "BIOTECH_PHARMACEUTICAL": "Biotech/Pharmaceutical",
    "BOOKSELLER": "Bookseller",
    "CONSTRUCTION": "Construction",
    "CASINOS_GAMBLING": "Casinos/Gambling",
    "CLOTHING": "Clothing",
    "CONSULTING_PROFESSIONAL_SERVICES": "Consulting/Professional Services",
    "CRYPTOCURRENCY": "Cryptocurrency",
    "ECIGARETTES_TOBACCO": "E-cigarettes/Tobacco",
    "ENERGY_CHEMICAL_FUEL": "Energy/Chemical/Fuel",
    "ENGINEERING": "Engineering",
    "ADULT_ENTERTAINMENT": "Adult Entertainment",
    "FINANCIAL_AND_CORPORATE_SERVICES": "Financial and Corporate Services",
    "FOOD_AND_BEVERAGE": "Food and Beverage",
    "FREIGHT_MARINE_SHIPPING_SERVICES": "Freight/Marine/Shipping Services",
    "GIFTWARE_SEASONAL": "Giftware/Seasonal",
    "GOVERNMENT_PUBLIC_SERVICES": "Government/Public Services",
    "HIGH_TECH_SOFTWARE_TELECOMS": "High Tech/Software/Telecoms",
    "HOSPITALITY": "Hospitality",
    "HOUSEHOLD_GOOD_FURNITURE": "Household Goods/Furniture",
    "HUMAN_RESOURCE_SERVICES": "Human Resource Services",
    "INDUSTRIAL_EQUIPMENT": "Industrial Equipment",
    "INFORMATION_TECHNOLOGY": "Information Technology",
    "INSURANCE": "Insurance",
    "JEWELLERY_OPTICAL": "Jewellery/Optical",
    "LAW": "Law",
    "MANUFACTURING": "Manufacturing",
    "MARKETING": "Marketing",
    "MEDIA_PUBLISHING": "Media/Publishing",
    "MEDICAL_HEALTHCARE": "Medical/Healthcare",
    "MEDICAL_TOURISM": "Medical Tourism",
    "MINING": "Mining",
    "MONEY_SERVICE_BUSINESS": "Money Service Business",
    "NON_PROFIT_CHARITY": "Non-Profit/Charity",
    "ONLINE_RETAIL": "Online Retail",
    "PAYROLL": "Payroll",
    "PENSION": "Pension",
    "PERSONAL_CARE_PRODUCTS": "Personal Care Products",
    "PHOTOGRAPHY": "Photography",
    "REAL_ESTATE": "Real Estate",
    "RECREATIONAL_ACTIVITIES": "Recreational Activities",
    "RELIGIOUS_ORGANISATION": "Religious Organisation",
    "RETAIL": "Retail",
    "SECURITY": "Security",
    "SPORTING_RECREATIONAL_PRODUCTS": "Sporting/Recreational Products",
    "TRANSPORT": "Transport",
    "UNIVERSITY_EDUCATION": "University/Education",
    "UTILITIES": "Utilities",
    "WASTE_MANAGEMENT": "Waste Management",
    "WINE_LIQUOR": "Wine/Liquor",
    "TECHNICAL_SUPPORT": "Technical Support",
    "OTHER": "Other"
  },
  "CounterPartyProfileFIATSGRelationshipToCustomer": {
    "SPOUSE": "Spouse",
    "EX_SPOUSE": "Ex-Spouse",
    "CHILDREN": "Children",
    "PARENT": "Parent",
    "SIBLING": "Sibling",
    "RELATIVE": "Relative",
    "SELF": "Self",
    "FRIEND": "Friend",
    "BUSINESS_PARTNER": "Business Partner",
    "CUSTOMER": "Customer",
    "EMPLOYEE": "Employee",
    "BRANCH_OFFICE": "Branch Office",
    "SUBSIDIARY_COMPANY": "Subsidiary Company",
    "HOLDING_COMPANY": "Holding Company",
    "SUPPLIER": "Supplier",
    "CREDITOR": "Creditor",
    "DEBTOR": "Debtor",
    "FRANCHISEE": "Franchisee",
    "NOT_RELATED": "Not Related"
  },
  "WithdrawalACHStatus": {
    "REQUESTED": "Requested",
    "REJECTED": "Rejected",
    "EXPIRED": "Expired",
    "ACCEPTED": "Accepted",
    "EXECUTED": "Executed",
    "CANCELLED": "Cancelled"
  },
  "WithdrawalACHWithdrawalRail": {
    "ACH": "ACH",
    "FEDWIRE": "Fedwire",
    "SWIFT": "SWIFT",
    "CRYPTO": "Crypto",
    "EFT": "EFT"
  },
  "WithdrawalACHPurpose": {
    "PERSONAL_ACCOUNT": "Personal Account",
    "FAMILY": "Family",
    "INSURANCE": "Insurance",
    "INVESTMENT": "Investment",
    "REAL_ESTATE": "Real Estate",
    "TUITION": "Tuition",
    "MEDICAL": "Medical",
    "TRAVEL": "Travel",
    "TRADE_TRANSACTIONS": "Trade Transactions",
    "UTILITY": "Utility",
    "TAX": "Tax",
    "LOAN": "Loan",
    "BILLS": "Bills",
    "PAYROLL": "Payroll",
    "TELECOM": "Telecom",
    "INTELLECTUAL_PROPERTY": "Intellectual Property",
    "OTHER_BUSINESS_SERVICES": "Other Business Services",
    "CHARITABLE_DONATIONS": "Charitable Donations",
    "MORTGAGE": "Mortgage",
    "EXPENSES_REIMBURSEMENT": "Expenses Reimbursement",
    "PROFESSIONAL_SERVICES": "Professional Services",
    "MARKETING": "Marketing",
    "RENTAL_PROPERTY": "Rental Property",
    "OTHER": "Other"
  },
  "AccountTypeOptions": {
    "FIAT": "FIAT",
    "CRYPTO": "Crypto"
  },
  "AccountAssetsCryptoOptions": {
    "BTC": "BTC",
    "ETH": "ETH",
    "USDC": "USDC",
    "USDT": "USDT",
    "DAI": "DAI",
    "MATIC": "MATIC",
    "SOL": "SOL",
    "TRX": "TRX"
  },
  "filteredOptions": {
    "BTC": "BTC",
    "ETH": "ETH",
    "USDC": "USDC",
    "USDT": "USDT",
    "DAI": "DAI",
    "MATIC": "MATIC",
    "SOL": "SOL",
    "TRX": "TRX"
  },
  "BlockchainCryptoOptions": {
    "BITCOIN": "Bitcoin",
    "ETHEREUM": "Ethereum",
    "POLYGON": "Polygon",
    "SOLANA": "Solana",
    "TRON": "Tron"
  },
  "AccountAssetsFiatOptions": {
    "USD": "USD",
    "EUR": "EUR"
  },
  "AssetsExchange": {
    "USD": "USD",
    "USDT": "USDT",
    "USDC": "USDC",
    "BTC": "BTC",
    "ETH": "Ethereum"
  },
  "CounterPartyRailsType": {
    "ACH": "ACH",
    "FEDWIRE": "Fedwire",
    "SWIFT": "Swift"
  },
  "BooleanEnum": {
    "YES": "Yes",
    "NO": "No"
  },
  "IndividualEmploymentStatus": {
    "EMPLOYEE": "Employee",
    "SELF_EMPLOYED": "Self Employed",
    "RETIRED": "Retired",
    "UNEMPLOYED": "Unemployed",
    "OTHER": "Other"
  }
}
